import { Component, OnInit, ElementRef, ViewChildren, QueryList, HostListener, HostBinding, Renderer2, Inject, ViewChild, ViewContainerRef, Injector, createNgModule, ComponentRef, ChangeDetectorRef, inject, DOCUMENT } from '@angular/core';
import { clickIsFromPointer, holdStampAfterStepChange, tapIsCarryover } from './tap-carryover';
import { watchKeyboardOpen } from '../../../../services/keyboard-viewport';
import { RateFreshnessService } from '../../../../services/rate-freshness.service';
import {
  addRateFinderBreadcrumb,
  captureRateFinderException,
  primeRateFinderSentryContext,
  updateRateFinderSentryContext,
} from '../../../../services/rate-finder-sentry';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, FormArray } from '@angular/forms';
import { StepAnimations } from './step-animations';
import { FirstNameLastNameComponent } from './steps/first-name-last-name/first-name-last-name.component';
// import { LendersCountComponent } from './steps/lenders-count/lenders-count.component';
import { EmailComponent } from './steps/email/email.component';
import { PhoneComponent } from './steps/phone/phone.component';
import { FruHttpService } from '../../../../services/fru-http.service';
import { PostLead } from '../../../../shared/post-lead';
import { SelectedResponse, SelectedList, DefaultSelectedResponse, DefaultSelectedResponseUnchecked } from '../../../../shared/selected-response.model';
import { Lead } from '../../../../shared/lead';
import { Rate } from '../../../../shared/rate.model';
import { StepComponent } from './step/step.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormResponse } from '../../../../shared/form-response';
import { NewHomeValueComponent } from './steps/new-home-value/new-home-value.component';
import { DscrEstimatedDownPaymentComponent, EstimatedDownPaymentComponent } from './steps/estimated-down-payment/estimated-down-payment.component';
import { ZipCodeComponent } from './steps/zip-code/zip-code.component';
import { FirstMortgageBalanceComponent } from './steps/first-mortgage-balance/first-mortgage-balance.component';
import { ZipCodeStreetAddressComponent } from './steps/zip-code-street-address/zip-code-street-address.component';
import { PropertyValueComponent } from './steps/property-value/property-value.component';
import { NeustarComponent } from './steps/neustar/neustar.component';
import { PropertyTypeComponent } from './steps/property-type/property-type.component';
import { DscrPropertyUseComponent, PropertyUseComponent } from './steps/property-use/property-use.component';
import { BankruptcyComponent } from './steps/bankruptcy/bankruptcy.component';
import { EmploymentComponent } from './steps/employment/employment.component';
import { CashOutComponent } from './steps/cash-out/cash-out.component';
import { CashOutReasonComponent } from './steps/cash-out-reason/cash-out-reason.component';
import { CurrentFHAComponent } from './steps/current-fha/current-fha.component';
import { CreditRatingComponent } from './steps/credit-rating/credit-rating.component';
import { VeteranMilitaryComponent } from './steps/veteran-military/veteran-military.component';
import { CurrentVAComponent } from './steps/current-va/current-va.component';
import { BuyingProcessComponent } from './steps/buying-process/buying-process.component';
import { FirstTimeBuyerComponent } from './steps/first-time-buyer/first-time-buyer.component';
import { MaximumHomeEquityComponent } from './steps/maximum-home-equity/maximum-home-equity.component';
import { LoanPurposeComponent } from './steps/loan-purpose/loan-purpose.component';
import { PropertyStatusComponent } from './steps/property-status/property-status.component';
import { TimeFrameComponent } from './steps/time-frame/time-frame.component';
import { LeadReferrerService } from '../../../../services/lead-referrer.service';
import { OfficeStatus } from '../../../../shared/office-status';
import { JornayaService } from '../../../../services/jornaya.service';
import { BrandService } from '../../../../services/brand.service';
import { BestService } from '../../../../services/best.service';
import { resolveProductPresentationFromParams, ProductPresentation } from '../../../../services/product-presentation';
import { AnalyticsService } from '../../../../services/analytics.service';
import { ExperimentService } from '../../../../services/experiment.service';
import { LoadScripts } from '../../../../services/load-scripts.service';
import { NeustarScore } from '../../../../shared/neustar-score';
import { CommunicationService } from '../../../../services/communication.service';
import { PropertyTypeConfirmationComponent } from './steps/property-type-confirmation/property-type-confirmation.component';
import { Title, Meta } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BankruptcyRecencyComponent } from './steps/bankruptcy-recency/bankruptcy-recency.component';
import { ReverseAgeComponent } from './steps/reverse-age/reverse-age.component';
import { fastModeFromQuery, isReverseQuery } from './reverse-flow';
import { ReverseBalanceComponent } from './steps/reverse-balance/reverse-balance.component';
import { ReverseResidenceComponent } from './steps/reverse-residence/reverse-residence.component';
import { StepsService } from '../../../../services/steps.service';
import { FastModeService } from '../../../../services/fast-mode.service';
import { HaveExistingMortgageComponent } from './steps/have-existing-mortgage/have-existing-mortgage.component';
import { ChatService as AiRateFinderChatService } from '../../../../ai-rate-finder/src/app/services/chat.service';
import { ChatAction } from '../../../../ai-rate-finder/src/app/models/chat-action.model';
import { QuoteToolService } from '../../../../services/quote-tool.service';
import { AGENT_ASSISTED_FIELD, QuoteAnswers, QuoteFormAdapter, sameQuoteStep } from '../../../../services/quote-tool';
import { answerQuoteLeaf, quotePhoneDigits, readQuoteLeaf } from '../../../../services/quote-step-reader';
import { applyEquityComparisonPolicy, resolveEffectiveRateRequest } from '../../../../services/advertised-rate-context';
import {
  AssistantImportRecoveryAction,
  claimAssistantFailureReport,
  handleAssistantImportFailure,
  loadAssistantModuleOnce,
} from '../assistant/assistant-loader';
import { watchFormBoot } from './form-boot';



@Component({
    selector: 'app-rates-form',
    templateUrl: './rates-form.component.html',
    styleUrls: ['./rates-form.component.scss'],
    animations: StepAnimations,
    standalone: false
})

export class RatesFormComponent implements OnInit {
  // Samsung Internet can leave the first-screen gradient unpainted behind transparent chat layers.
  // This marker is only used to move that paint onto the conversation body for that browser.
  readonly hopeSamsungInternet = typeof navigator !== 'undefined' && /SamsungBrowser\//i.test(navigator.userAgent || '');

  // Ed 8/7: rates-checked stamp renders as a small centered line above * Advertising Disclosure.
  public rateFreshness = inject(RateFreshnessService);

  // FRU-23700: browser agents' quote-form tools (services/quote-tool.ts) read this form's current question and answer it
  // through the step's own submit, as a tap would. They stop at the phone step and never submit. Hope takes over while it
  // is on screen. Nothing here runs unless an agent calls a tool.
  private quoteTool = inject(QuoteToolService);
  private readonly quoteAdapter: QuoteFormAdapter = {
    arm: 'original',
    currentStep: () => {
      if (this.showAssistant || this.isSubmitting || !Array.isArray(this.steps)) { return null; }
      const step: any = this.steps[this.currentStepKey];
      const inst: any = this.stepComponents?.[this.currentStepKey]?.cmpRef?.instance;
      if (!step || !step.key || !inst) { return null; }
      return readQuoteLeaf(inst, this.form, step.key, step.key === 'phone');
    },
    answer: (step, answers) => {
      const inst: any = this.stepComponents?.[this.currentStepKey]?.cmpRef?.instance;
      if (!inst || !sameQuoteStep(this.quoteAdapter.currentStep(), step)) { return 'the form moved to another question'; }
      return answerQuoteLeaf(inst, this.form, step, answers);
    },
    markAgentAssisted: () => this.setFormControlValue(AGENT_ASSISTED_FIELD, '1'),
    prefillPhone: (raw) => {
      const d = quotePhoneDigits(raw);
      if (!d) { return false; }
      this.setFormControlValue('phoneNumber', '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6));
      return true;
    },
    switchHint: (answers) => this.quoteLoanTypeHint(answers),
  };

  /** The original form's questions follow its loan type, set by the page's link. A different loan type is a different link. */
  private quoteLoanTypeHint(answers: QuoteAnswers): string {
    const wanted = String((answers && answers['loanPurpose']) || '').toLowerCase().trim();
    if (!wanted) { return ''; }
    const formQuery: { [k: string]: string } = {
      refinance: 'LoanPurpose=refinance&lp_button=refinance',
      purchase: 'LoanPurpose=purchase&lp_button=purchase',
      heloc: 'LoanPurpose=refinance&FormType=heloc&lp_button=homeequity',
      cashout: 'LoanPurpose=refinance&FormType=cashout&lp_button=cashout',
      homeimprovement: 'LoanPurpose=refinance&FormType=homeimprovement&lp_button=homeimprovement',
    };
    if (!formQuery[wanted]) { return 'loanPurpose must be one of ' + Object.keys(formQuery).join(', ') + '.'; }
    const sub = ['heloc', 'cashout', 'homeimprovement'].indexOf((this.formType || '').toLowerCase()) >= 0 ? this.formType.toLowerCase() : '';
    const current = sub || (this.type || '').toLowerCase();
    if (!current || current === wanted) { return ''; }
    return 'This page asks the questions for ' + current + '. For ' + wanted + ', open /communication/rates-form?' + formQuery[wanted]
      + ' on this site, then call this tool again with the same answers.';
  }

  get rateProvenance(): Rate | null {
    const rate = this.fruHttp.currentEffectiveAdvertisedRate();
    return rate
      && Number.isSafeInteger(rate.rates_checked_timestamp)
      && (rate.rates_checked_timestamp as number) > 0
      && !!rate.disclosure
      ? rate
      : null;
  }

  @ViewChildren(StepComponent) stepComponentList: QueryList<StepComponent>
  @HostListener('window:keyup', ['$event'])
  KeyEventsPlugin(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      // if (this.showPrompt) {
      //   this.continueWith('yes');
      //   return;
      // }

      if (typeof this.stepComponents[this.currentStepKey] !== 'undefined'
        && typeof this.stepComponents[this.currentStepKey].enterPress === 'function') {
        this.stepComponents[this.currentStepKey].enterPress();
      }
    }
  }
  @HostListener('window:blur', ['$event.target'])
  onBlur() {
    if (this.changeTabTitleIfTabLeaves) {
      this.timerId = window.setTimeout(() => {
        this.titleService.setTitle('Get Rates Now!');
      }, 5000);
    }
  }
  @HostListener('window:focus', ['$event.target'])
  onFocus() {
    if (this.changeTabTitleIfTabLeaves && this.timerId) {
      window.clearTimeout(this.timerId);
      this.timerId = null;
      this.titleService.setTitle(this.tabTitle);
    }
  }

  @HostBinding('class') themeName = this.getThemeName();

  officeStatus: OfficeStatus;
  neustarScore: NeustarScore;
  phoneScore: Number;
  stepComponents: Array<StepComponent>;
  form: UntypedFormGroup;
  type: string;
  formType: string;
  lp_button: string;
  objectKeys = Object.keys;
  state: string = 'inactive';
  currentStepKey: number = 0;
  stepHistory: Array<number> = [];
  debug: boolean;
  queryStringStep: string;
  currentDate: string = '';
  currentTime: string = '';
  removeBackgroundPhoneEmailStep: boolean = false;
  neustarTest: boolean = false;
  utm_campaign: string;
  utm_source: string;
  fruLocal: boolean = false;
  fruLocalKiosk: boolean = false;
  isTopTenBestLenders: boolean = false;
  showModal: boolean = false;
  leadDisclosure:boolean = false;
  protected experimentData: any;
  // FRU-21436: LowRateFinder conversational-AI flip (A/B). Set true only for the variation arm.
  aiAssistantEnabled = false;
  // FRU-21436: startAssistant=0 means show the switch pill; no param means original/no assistant UI.
  showAiAssistantSwitch = false;
  // FRU-21436: in-place flip flag. true => hide the form steps and render <app-chat>.
  showAssistant = false;
  // FRU-21436: one-shot guard so ?startAssistant=1 auto-opens the chat exactly once on load.
  private autoStartAssistantFired = false;
  // FRU-21436: hide traditional form/landing chrome while the direct assistant launch is waiting for init.
  assistantLaunchPending = false;
  // FRU-21436: snapshot of answers handed to the chat at flip time (preserves progress).
  assistantSeed: { [key: string]: any } | null = null;
  // Landing-only assumptions survive a slow import; ordinary form answers are rebuilt from the
  // live controls at mount time so removed/backed-out answers cannot be resurrected.
  private assistantSeedCarryover: { [key: string]: any } = {};
  // FRU-21436: anchor where the lazy-loaded chat component is rendered at runtime.
  @ViewChild('assistantHost', { read: ViewContainerRef }) assistantHost: ViewContainerRef;
  // FRU-21436: handle to the dynamically created chat component (so we can clean it up on flip-back).
  private assistantComponentRef: ComponentRef<any> | null = null;
  // FRU-21436: guards against double-loading the lazy chunk on repeated flips.
  private assistantLoading = false;
  // FRU-22418: a failed Hope chunk must expose a usable, truthful classic path instead of leaving
  // a blank overlay or a switch that can only reject the same sticky module request again.
  assistantLoadFailed = false;
  private assistantModuleLoader = loadAssistantModuleOnce;
  private recoverAssistantImport = handleAssistantImportFailure;
  // FRU-21436: answers carried back from the chat on "Switch Back", keyed by FORM control name.
  // Re-applied in activateStep() so controls that only exist once their step renders still get filled.
  private switchBackSeed: { [key: string]: any } | null = null;
  private rateFinderFlipSeq = 0;
  private rateFinderActionSeq = 0;
  steps;
  tabTitle: string;
  changeTabTitleIfTabLeaves: boolean;
  // FRU-21694: dynamic product presentation. productH1 is '' for generic/organic/control entries
  // (no product H1 rendered), non-empty only when an ad product is resolved from the URL.
  productH1 = '';
  productPresentation: ProductPresentation | null = null;
  timerId: number;
  currentYear: number = 2023;
  isSubmitting:boolean = false;
  siteLogo: boolean = false;
  userExiting: boolean = false;
  hasSeenPopup: boolean = false;
  mouseMoved: boolean = false;
  loanPurpose: string;
  recommendedLenderActive: boolean = false;
  removeTrackers: boolean = false;
  top10FormDesign2025: boolean = false;
  paramType: string = '';
  progressBarValue: number = 0;
  progressBarMax: number = 1;
  isSrcExitPopup: boolean = false;
  isTop10newFooterForm: boolean = false;
  isFastModeAllowed: boolean = false;
  hasFastModeBeenEnabled: boolean = false;
  hasAIModeBeenEnabled: boolean = false;
  fastModeEnabledStep: string = '';
  isFullFastFlow: boolean = false;
  // FRU calc-skin: render the rates-form as a home-equity calculator (A/B variant, ad traffic). Home-equity loan type pre-set on landing; no loan-type step.
  calcSkin: boolean = false;
  // FRU calc-skin: LTV used for the "how much can I access" estimate (no rate advertised — equity math only).
  calcLtv: number = 0.80;
  // FRU calc-skin: credit-aware LTV for the equity estimate (typical home-equity caps; conservative). No rate involved.
  private get calcLtvForCredit(): number {
    const c = String(this.form?.controls?.['creditRating']?.value || '').toLowerCase();
    if (c.includes('excellent')) { return 0.85; }
    if (c.includes('good')) { return 0.80; }
    if (c.includes('fair')) { return 0.75; }
    if (c.includes('poor')) { return 0.70; }
    return this.calcLtv;
  }
  // Available-equity estimate from the form's own fields. NO RATE / NO PAYMENT (Reg Z / UDAAP: never advertise a rate on the collection page).
  get calcAvailableEquity(): number | null {
    try {
      const hv = parseFloat(String(this.form?.controls?.['propertyValue']?.value || '').replace(/[^0-9.]/g, ''));
      const bal = parseFloat(String(this.form?.controls?.['firstMortgageBalance']?.value || '').replace(/[^0-9.]/g, ''));
      if (!hv || isNaN(hv)) { return null; }
      const balance = (!bal || isNaN(bal)) ? 0 : bal;
      const ltv = this.calcLtvForCredit;
      const eq = Math.max(0, Math.round((hv * ltv - balance) / 1000) * 1000);
      return eq;
    } catch (e) { return null; }
  }
  // LTV actually used (for the on-screen "~X% loan-to-value" note)
  get calcLtvDisplay(): number { return Math.round(this.calcLtvForCredit * 100); }


  /** FRU calc-skin: subtle common-knowledge tip about how the current item affects rate/payment. */
  get calcStepTip(): string {
    const key = (this.steps && this.steps[this.currentStepKey]) ? this.steps[this.currentStepKey].key : '';
    const tips: { [k: string]: string } = {
      loanPurpose: 'Your loan type shapes the rate range lenders can offer.',
      propertyType: 'Single-family homes usually see the best rates; other property types can price a bit higher.',
      propertyUse: 'A primary home typically gets a lower rate than a second home or investment property.',
      propertyValue: 'A higher home value versus what you owe means more equity, which can improve your terms.',
      newHomeValue: 'A higher home value versus what you owe means more equity, which can improve your terms.',
      firstMortgageBalance: 'The less you owe relative to your home value, the lower your loan-to-value and often the better the rate.',
      maximumEquity: 'Borrowing less of your available equity generally means a lower rate.',
      cashOut: 'Taking more cash out raises your loan-to-value, which can nudge the rate up.',
      creditRating: 'Higher credit scores typically qualify for lower rates and payments.',
      currentFHA: 'An existing FHA loan can open up streamlined refinance options.',
      veteranMilitary: 'VA-eligible borrowers often access lower rates and no PMI.',
      estimatedDownPayment: 'A larger down payment lowers your loan-to-value and can reduce your rate.',
      zip: 'Rates vary by location, so your area helps us match the right lenders.',
      zipCodeStreetAddress: 'Your location helps confirm home value and match local lenders.',
      phone: 'Almost there. This lets a matched lender share your personalized quote.',
      email: 'Almost there. We use this to send your matched options, no spam.',
    };
    return tips[key] || 'Each answer helps us estimate a more accurate rate and payment.';
  }

  /** FRU-25273: the property type step goes without the phones' 64px top padding. */
  get onPropertyTypeStep(): boolean {
    return this.steps?.[this.currentStepKey]?.key === 'propertyType';
  }

  get isFastModePhoneStep(): boolean {
    return this.isFastModeAllowed && this.steps && this.steps[this.currentStepKey]?.key === 'phone';
  }

  get hideFastModeChrome(): boolean {
    return this.isSubmitting || (this.steps && this.steps[this.currentStepKey]?.key === 'phone' && (this.isFastModeAllowed || this.isFullFastFlow));
  }

  private includeFastModeExperimentData(): void {
    if (this.route.snapshot.queryParams['fast_variant'] !== 'yes') {
      return;
    }

    if (!this.experimentData || !Array.isArray(this.experimentData.enabledExperiments)) {
      this.experimentData = { enabledExperiments: [] };
    }

    const hasFastModeExperiment = this.experimentData.enabledExperiments.some((experiment) => {
      return experiment.experiment === 'FRU-21170-Fast-Flow-v3';
    });

    if (!hasFastModeExperiment) {
      this.experimentData.enabledExperiments.push({
        experiment: 'FRU-21170-Fast-Flow-v3',
        variation: 'FRU-21170-v3',
        hit_segment: true
      });
    }
  }

  private includeAiAssistantExperimentData(): void {
    if (this.route.snapshot.queryParams['startAssistant'] === undefined) {
      return;
    }

    if (!this.experimentData || !Array.isArray(this.experimentData.enabledExperiments)) {
      this.experimentData = { enabledExperiments: [] };
    }

    const hasAiAssistantExperiment = this.experimentData.enabledExperiments.some((experiment) => {
      return experiment.experiment === 'FRU-21436-low-rate-finder';
    });

    if (!hasAiAssistantExperiment) {
      this.experimentData.enabledExperiments.push({
        experiment: 'FRU-21436-low-rate-finder',
        variation: 'FRU-21436',
        hit_segment: true
      });
    }
  }

  private includeLandingAiBoxExperimentData(): void {
    const assistantSource = this.route.snapshot.queryParams['assistantSource'];
    if (assistantSource !== 'landing' && assistantSource !== 'calculator') {
      return;
    }

    if (!this.experimentData || !Array.isArray(this.experimentData.enabledExperiments)) {
      this.experimentData = { enabledExperiments: [] };
    }

    const hasLandingAiBoxExperiment = this.experimentData.enabledExperiments.some((experiment) => {
      return experiment.experiment === 'FRU-21526-lp-ai-box-v6-2';
    });

    if (!hasLandingAiBoxExperiment) {
      this.experimentData.enabledExperiments.push({
        experiment: 'FRU-21526-lp-ai-box-v6-2',
        variation: 'FRU-21526-v6-2',
        hit_segment: true
      });
    }
  }

  // FRU-21478: the A/B arm assignment is a SERVER-set cookie (experiment_<name>=<variation>,
  // MY_Controller + InnoCraft, path=/, 2yr). Matomo's getExperiments() only fires on the landing
  // page, so experimentData is empty on ~98% of submits (the 11/1700 Saturday miss). Recover only
  // sticky cookies carrying the server's short-lived current-entry companion, then merge at submit.
  private readExperimentCookies(): Array<{ experiment: string, variation: string, hit_segment: boolean }> {
    return ExperimentService.currentCookieAssignments(document.cookie || '');
  }

  private mergeExperimentCookieTruth(): void {
    const cookieEntries = this.readExperimentCookies();
    if (!this.experimentData || !Array.isArray(this.experimentData.enabledExperiments)) {
      this.experimentData = { enabledExperiments: [] };
    }
    this.experimentData.enabledExperiments = ExperimentService.mergeCurrentExperimentCookieTruth(
      window.location.search,
      this.experimentData.enabledExperiments,
      cookieEntries
    );
  }

  private setFormControlValue(controlName: string, value: any): void {
    if (this.form.controls[controlName]) {
      this.form.controls[controlName].setValue(value);
    } else {
      this.form.addControl(controlName, new UntypedFormControl(value));
    }
  }

  // Selected Lead
  isSelectedLeads$: BehaviorSubject<boolean> = new BehaviorSubject(false); // We display it omle for searchmortgagerate.com for now
  isChecked: number = 1;
  availableSelected$: BehaviorSubject<SelectedResponse> = new BehaviorSubject({
    lead_id: 0,
    lenders: []
  });
  notSubmitedLeadId: number = 0;
  // showPrompt: boolean = false;
  // isContinueRedirect$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  // promptAllowed: boolean = false;
  // promptAsked: boolean = false;
  featuredLender: SelectedList;
  promptText: string = '';
  promptType: string = ''; // deselected all or featured?
  cancelSelectedRequest: boolean = false;

  defaultResponse: SelectedResponse = DefaultSelectedResponse;

  // isUncheckedTest$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // isLendersCount$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isCashOutSet: boolean = false;
  cashOutAmount: number = 0;

  clientId: string;
  beState: string;
  isBeEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  isSecureForm: boolean = false;

  stateByIp: string;

  private exitIntentListener: () => void;
  /** Set on destroy: the original form's loading-skeleton watch (form-boot.ts) stops. */
  private formBootWatchStopped = false;
    regularStepLength: number = 0;

  private componentMappings: { [key: string]: any } = {
    // 'bankruptcy': BankruptcyComponent,
    // 'bankruptcy-recency': BankruptcyRecencyComponent,
    'buyingProcess': BuyingProcessComponent,
    'cashOut': CashOutComponent,
    'cashOutReason': CashOutReasonComponent,
    'creditRating': CreditRatingComponent,
    'currentFHA': CurrentFHAComponent,
    'currentVA': CurrentVAComponent,
    'email': EmailComponent,
    // 'lendersCount': LendersCountComponent,
    // 'selfEmployed': EmploymentComponent,
    'estimatedDownPayment': EstimatedDownPaymentComponent,
    'firstNameLastName': FirstNameLastNameComponent,
    'firstMortgageBalance': FirstMortgageBalanceComponent,
    'haveExistingMortgage': HaveExistingMortgageComponent,
    'firstTimeBuyer': FirstTimeBuyerComponent,
    'loanPurpose': LoanPurposeComponent,
    'maximumEquity': MaximumHomeEquityComponent,
    'neustar': NeustarComponent,
    'newHomeValue': NewHomeValueComponent,
    'phone': PhoneComponent,
    'propertyStatus': PropertyStatusComponent,
    'propertyType': PropertyTypeComponent,
    'propertyTypeConfirmation': PropertyTypeConfirmationComponent,
    'propertyValue': PropertyValueComponent,
    'propertyUse': PropertyUseComponent,
    'reverseAge': ReverseAgeComponent,
    'reverseBalance': ReverseBalanceComponent,
    'reverseResidence': ReverseResidenceComponent,
    'timeFrame': TimeFrameComponent,
    'veteranMilitary': VeteranMilitaryComponent,
    'zipCode': ZipCodeComponent,
    'zipCodeStreetAddress': ZipCodeStreetAddressComponent
  };

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private fruHttp: FruHttpService,
    private route: ActivatedRoute,
    private router: Router,
    private leadReferrerService: LeadReferrerService,
    private jornayaService: JornayaService,
    private communicationService:CommunicationService,
    public brandService: BrandService,
    public best: BestService,
    public deviceService: DeviceDetectorService,
    public analyticsService: AnalyticsService,
    private titleService: Title,
    private meta: Meta,
    private loadScripts: LoadScripts,
    private stepsService: StepsService,
    public fastMode: FastModeService,
    private injector: Injector,
    private cdr: ChangeDetectorRef,
    private aiRateFinderChatService: AiRateFinderChatService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.stepHistory.push(0);
    this.tabTitle = this.titleService.getTitle();
    this.isFullFastFlow = !this.isDscrInvestmentFlow() && this.route.snapshot.queryParams['fast_variant'] === 'yes';
    this.calcSkin = this.route.snapshot.queryParams['calc'] === 'homeequity' || this.route.snapshot.queryParams['calcSkin'] === '1';
    // FRU-23823: only a cold direct entry suppresses Classic while Hope imports. A later
    // in-form switch must leave the already-mounted controls and consumer answers intact.
    this.assistantLaunchPending = this.shouldStartAssistantFromUrl();
    this.syncAssistantExperimentFromUrl();

    let d = new Date();
    this.currentYear = d.getFullYear();

    if(this.route.snapshot.queryParams['recommendedLender'] == 'true') {
			this.recommendedLenderActive = true;
		}

    // Exit intent listener
    var prevMouseYPosition = 100;
    let mouselistener = this.renderer.listen("document", "mousemove", event => {
      this.mouseMoved = true;
    });

    // FRU-21436: arm exit-intent only on a genuine large, non-touch screen. deviceService.isDesktop()
    // is user-agent based, so tablets/iPads slipped through and a narrow window could trip it, covering
    // small screens with no reliable mouse-leave. Require a wide viewport AND no touch.
    const isLargeNonTouch = typeof window !== 'undefined'
      && window.innerWidth >= 1024
      && !('ontouchstart' in window)
      && (navigator.maxTouchPoints || 0) === 0;
    if (this.deviceService.isDesktop() && isLargeNonTouch) {
      this.exitIntentListener = this.renderer.listen("document", "mouseout", event => {
        const shouldShowExitIntent = !this.hasSeenPopup && this.mouseMoved && event.clientY < 10 && prevMouseYPosition < 100;

        if (shouldShowExitIntent) {
          document.removeEventListener("mouseout", this.exitIntentListener);
          this.showExitIntentPopup();
          this.analyticsService.trackGoal(60);
        }

        prevMouseYPosition = event.clientY;
      });
    }

    if (this.brandService.domain.includes('top10bestlenders')) {
      this.top10FormDesign2025 = true;
      this.isTop10newFooterForm = true;
    }

    // AB Test activations
    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        //if no segment is required we can just set a true value at the start of the test
        /** @ToDo implement hit_segment */
        let hit = { hit_segment: true };
        variationData.enabledExperiments.forEach((x) => {
          Object.assign(x, hit);
        });
        this.experimentData = { enabledExperiments: variationData.enabledExperiments };
        this.syncAssistantExperimentFromUrl();
        // FRU-21436: arriving with ?startAssistant=1 lands the user straight in the
        // chat. Trigger after experiments resolve (this is where aiAssistantEnabled becomes true) so
        // the gate is respected. No prior answers on this path => chat starts fresh and asks loan type.
        this.maybeAutoStartAssistant();
        if (variationData.enabledVariations.hasOwnProperty('RemoveBackgroundPhoneEmailStep')) {
          this.removeBackgroundPhoneEmailStep = true;
        }
        if (variationData.enabledVariations.hasOwnProperty('SiteLogo')) {
          this.siteLogo = true;
        }
        if (variationData.enabledVariations.hasOwnProperty('NeustarLoadingState')) {
          this.neustarTest = true;
        }

        //FRU-13214-a-b-test-change-tab-title-if-tab-leaves-focus
        this.changeTabTitleIfTabLeaves = variationData.enabledVariations.hasOwnProperty('ChangeTabTitleIfTabLeaves');

        // if (variationData.enabledVariations.hasOwnProperty('selectedJan27')) {
        //   if ((this.brandService.domain.includes('homeequitychoice')
        //     || this.brandService.domain.includes('freerateupdate')
        //     || this.brandService.domain.includes('besthomeequityloan'))
        //     && this.brandService.view != 'best'
        //   ) {
        //     this.isSelectedLeads$.next(true);
        //     this.isChecked = 1;
        //   }
        // }

        // if (variationData.enabledVariations.hasOwnProperty('selectedTop10Jan27')) {
        //   if (this.brandService.domain.includes('top10bestlenders')) {
        //     this.isSelectedLeads$.next(true);
        //     this.isChecked = 1;
        //   }
        // }

        // if (variationData.enabledVariations.hasOwnProperty('uncheckedReq')) {
        //   this.isUncheckedTest$.next(true);
        //   this.isChecked = 0;
        // }

        // if (variationData.enabledVariations.hasOwnProperty('lendersCount3')) {
        //   if (this.brandService.domain.includes('homeequitychoice')
        //     || this.brandService.domain.includes('freerateupdate')
        //     || this.brandService.domain.includes('besthomeequityloan')) {
        //     this.isLendersCount$.next(true);
        //   }
        // }

        if (variationData.enabledVariations.hasOwnProperty('secureForm')) {
          if (this.brandService.domain.includes('top10bestlenders')
          ) {
            this.isSecureForm = true;
          }
        }
      }
    );

    //get array of steps
    this.initializeSteps();
    //catch event from phone component
    this.communicationService.modalClosed.subscribe(
      (status: boolean) => {
        if (status) { this.toggleModal(); }
      });
  }

  private setProgressBar() {
    if (!Array.isArray(this.steps) || this.steps.length === 0) return;
    
    this.progressBarMax = this.steps.length;
    this.progressBarValue = Math.min(this.currentStepKey + 1, this.progressBarMax);
  }

  // Add favicon links to header for given path
  private addFaviconLinks(faviconPath: string): void {
    const links = [
      { rel: 'shortcut icon', type: 'image/ico', href: `${faviconPath}favicon.ico` },
      { rel: 'apple-touch-icon', sizes: '180x180', href: `${faviconPath}apple-touch-icon.png` },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: `${faviconPath}favicon-32x32.png` },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: `${faviconPath}favicon-16x16.png` },
      { rel: 'manifest', href: `${faviconPath}site.webmanifest` },
    ];

    links.forEach(({ rel, href, type, sizes }) => {
      const link: HTMLLinkElement = this.document.createElement('link');
      link.rel = rel;
      link.href = href;

      if (type) link.type = type;
      if (sizes) link.setAttribute('sizes', sizes);

      this.document.head.appendChild(link);
    });
  }

  // FRU-24782: when nextStep() last moved forward, and the capture-phase listener that holds a carried-over tap on the
  // form for TAP_CARRYOVER_MS after it. Capture phase on the host, so it runs before the step's own click handler.
  private stepAdvancedAt = 0;
  private readonly holdCarriedTap = (event: MouseEvent): void => {
    try {
      const t = event.target as HTMLElement;
      const onTheForm = !!(t && typeof t.closest === 'function' && t.closest('#mainForm'));
      if (tapIsCarryover(Date.now(), this.stepAdvancedAt, clickIsFromPointer(event), onTheForm)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    } catch (e) { /* non-fatal */ }
  };

  /** FRU-25273: the on-screen keyboard is up (Hope's rules, services/keyboard-viewport.ts); the phone call card steps aside. */
  keyboardOpen = false;
  private stopKeyboardWatch: () => void = () => {};

  ngOnDestroy() {
    this.stopKeyboardWatch();
    this.formBootWatchStopped = true;
    this.quoteTool.clearBase(this.quoteAdapter);   // FRU-23700
    try { this.elementRef.nativeElement.removeEventListener('click', this.holdCarriedTap, true); } catch (e) { /* FRU-24782 */ }
  }

  ngOnInit() {
    this.quoteTool.setBase(this.quoteAdapter);   // FRU-23700
    this.stopKeyboardWatch = watchKeyboardOpen(open => { this.keyboardOpen = open; });
    try { this.elementRef.nativeElement.addEventListener('click', this.holdCarriedTap, true); } catch (e) { /* FRU-24782 */ }
    primeRateFinderSentryContext(
      'form',
      true,
      this.fruHttp.rateFinderConversationContext(),
      this.steps?.[this.currentStepKey]?.key || this.route.snapshot.queryParams['step'] || 'loanPurpose',
    );
    // FRU-21811 (paid-mobile P0): a direct-Hope entry ALWAYS needs the assistant chunk, but the old
    // flow waited for form init + the open sequence before even requesting it -- serialising two
    // round-trips after main.js. Kick the dynamic import off NOW so it downloads in parallel with the
    // rest of bootstrap (the module cache makes the later import in openAiAssistant a no-op hit).
    try {
      if (!this.isDscrInvestmentFlow() && /[?&]startAssistant=1(?:&|$)/i.test(window.location.search)) {
        addRateFinderBreadcrumb('assistant_chunk_load_start', { source: 'component_prefetch' });
        this.assistantModuleLoader().then(() => {
          addRateFinderBreadcrumb('assistant_chunk_load_success', { source: 'component_prefetch' });
        }).catch((error) => {
          const recoveryAction = this.recoverAssistantImport('component_prefetch');
          if (claimAssistantFailureReport()) {
            captureRateFinderException(error, 'assistant_chunk_load_failure', {
              source: 'component_prefetch',
              recovery_action: recoveryAction,
            });
          }
        });
        // FRU-21810 perf: ui_config used to start only after the lazy chunk initialised
        // (t~2.2s measured). It is idempotent (window + sessionStorage + in-flight guard),
        // so it is safe to fire immediately. The scoped rate prime runs below, after the
        // requested product presentation has been resolved.
        try { this.fruHttp.ensureUiConfig(); } catch (e) { /* non-fatal */ }
      }
    } catch (e) { /* non-fatal */ }
    this.removeTrackers = !!window['removeTrackers'] || document.cookie.split(';').some(cookie => cookie.trim().startsWith('fruRemoveCookies'));
    
    // Add favicon links
    if (this.brandService.data.domain === 'top10bestlenders.com') {
      this.addFaviconLinks('/application/views/www/public/assets/img/top10-favicon-files/');
    }
    
    // Set lead_referrer cookie if the LP was skipped
    this.leadReferrerService.setReferrer();

    // Set meta description
    const prettyDomain = this.brandService.data.prettyDomain || 'FreerateUpdate';
    // FRU-21694: dynamic product presentation for direct product entries — the <title>, meta description,
    // and a compact visible H1 all agree with the ad's product (Google Ads landing-page relevance). The
    // BASE product drives the form/lead identity (loanPurpose/formType/lp_button, #1102 contract); VA/FHA/
    // Jumbo layer on as an eligibility program in the copy. Generic / organic / control visitors resolve to
    // 'generic' -> today's exact title + brand description + NO product H1, so nothing leaks onto the shared
    // form for non-product traffic.
    let presentation: ProductPresentation | null = null;
    let isDirectHopeEntry = false;
    try {
      const qp = new URLSearchParams((typeof window !== 'undefined' && window.location.search) || '');
      // FRU-21694 (abx #1): apply the product presentation ONLY for an actual direct-Hope entry
      // (startAssistant=1). A normal / organic / control /rates-form?type=... is left UNCHANGED.
      isDirectHopeEntry = !this.isDscrInvestmentFlow() && qp.get('startAssistant') === '1';
      // FRU-21694 + FRU-22465: title/meta must use the same selected URL intent as Hope's
      // opener, reviewed rate and questionnaire. The old local concatenation put
      // utm_keyword before keyword and could title the page for product A while Hope quoted
      // product B. The shared URL resolver owns both the parameter order and route conflicts.
      presentation = resolveProductPresentationFromParams(qp, prettyDomain);
    } catch (e) { presentation = null; }

    if (isDirectHopeEntry && presentation && this.loanPurpose !== 'personalloan') {   // FRU-21801: apply the product title/meta for EVERY direct-Hope entry (calculator/today/no-type were falling to the site-generic title); resolver always returns an on-topic title. isDirectHopeEntry gate keeps the original/control form untouched.
      this.productPresentation = presentation;
      this.fruHttp.rememberEffectiveAdvertisedRateProgram(presentation.program);
      this.productH1 = presentation.h1;
      this.titleService.setTitle(presentation.title);
      if (presentation.description) { this.meta.updateTag({ name: 'description', content: presentation.description }); }
    } else {
      // generic / personal-loan (UNCHANGED behavior)
      this.fruHttp.rememberEffectiveAdvertisedRateProgram('');
      this.brandService.updateMetaDescription(this.meta);
      const title = this.loanPurpose === 'personalloan'
        ? `Debt Consolidation & Personal Loans | ${prettyDomain}`
        : `Mortgage Refinance & Purchase, Home Equity & Cash Out Loans | ${prettyDomain}`;
      this.titleService.setTitle(title);
    }

    if (isDirectHopeEntry) {
      this.primeEffectiveRateCache();
    }

    // Add open graph social media link preview
    if (this.brandService.isTop10) {
      const ogTitle = this.titleService.getTitle();
      const ogUrl = document?.location?.href || '';
      const ogImage = 'https://www.top10bestlenders.com/application/views/www/public/assets/img/top10-social-media/top10-social-media-link-preview-1200x630.jpg';
      const ogDescription = this.meta.getTag('name=description')?.content || 'Compare top mortgage lenders for low rates, reviews, and personalized deals.';
      const tags: Array<any> = [
        { property: 'og:title', content: ogTitle },
        { property: 'og:description', content: ogDescription },
        { property: 'og:image', content: ogImage },
        { property: 'og:url', content: ogUrl },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: prettyDomain },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: ogTitle },
        { name: 'twitter:description', content: ogDescription },
        { name: 'twitter:image', content: ogImage },
      ];
      tags.forEach(tag =>
        this.meta.updateTag(tag, tag.property ? `property='${tag.property}'` : `name='${tag.name}'`)
      );
    }

    // Get query string
    this.route.queryParams.subscribe(params => {
      this.syncAssistantExperimentFromUrl();
      // FRU-21436: defend against duplicated URL params (e.g. ?LoanPurpose=refinance&LoanPurpose=refinance),
      // which Angular parses as an array. .toLowerCase() below would throw on an array, and an array value
      // propagated into the assistant seed silently restarted the chat at step 0. Coerce to a scalar.
      const scalar = (v: any) => Array.isArray(v) ? (v[0] ?? '') : v;
      this.type = scalar(params.LoanPurpose) || '';
      // FRU calc-skin: home-equity calculator presets the loan type so there is NO loan-type step.
      // (?calc=homeequity from the ad/landing) — home-equity is served by the refinance step flow.
      if ((params.calc === 'homeequity' || params.calcSkin === '1') && !this.type) {
        this.type = 'refinance';
      }
      this.debug = typeof params.debug !== 'undefined';
      this.queryStringStep = params.step || null;
      this.formType = scalar(params.FormType) || '';
      this.lp_button = scalar(params.lp_button) || '';
      this.utm_campaign = params.utm_campaign || null;
      this.utm_source = params.utm_source || null;
      this.fruLocal = this.utm_source == 'FRULocal';
      this.isTopTenBestLenders = this.brandService.isTop10;
      this.fruLocalKiosk = this.utm_campaign == 'FRULocalKiosk';
      this.communicationService.fruLocal = this.fruLocal;
      this.communicationService.fruLocalKiosk = this.fruLocalKiosk;
      this.paramType = scalar(params.type);
      if (this.brandService.pageType === 'default' && params.type) {
        this.brandService.pageType = params.type;
      }
      this.isSrcExitPopup = params.fru_source == 'ExitPopup';

      this.clientId = params.l || null;
      this.beState = params.state || null;

      // Fix up old bad urls
      this.type = this.type.toLowerCase();
      this.formType = this.formType.toLowerCase();
      this.cashOutAmount = params.cashout || 0;
      if (this.cashOutAmount > 0) {
        this.isCashOutSet = true;
      }

      this.communicationService.maxCashoutForm = params.maxCashoutForm === "yes";
      // If no type, redirect to landing page
      // or no more steps and someone pushed go back in browser
      if(typeof this.steps === 'undefined') {
        return;
      }
      if(this.currentStepKey >= this.steps.length) {
        return this.router.navigate(['/form-landing'], { queryParams: !params.type ? { type: 'default' } : {}, queryParamsHandling: 'merge' });
      }
      // If step key not exists (sometime it happen in mobile Safari/Chrome on iPhone)
      if (typeof this.steps[this.currentStepKey] === 'undefined'
        || typeof this.steps[this.currentStepKey].key === 'undefined') {
        let nextStep = this.currentStepKey - 1;
        if (nextStep >= 0) {
          this.nextStep(nextStep);
        }
      }

      this.regularStepLength = this.steps.length - 3; //(this.lp_button == 'personalloan' ? 2 : 3);
      // FRU-21436: keep the visible step in lock-step with the URL ?step= param. This fires on back/
      // forward navigation. Previously gated on currentStepKey > 0, which left a desync after the AI
      // flip: browser Forward to e.g. step=creditRating while currentStepKey was 0 was ignored, so the
      // URL said creditRating but the form still showed Type of Home. Sync whenever the URL names a
      // real step that differs from the one on screen.
      if (this.steps && this.queryStringStep
        && this.queryStringStep !== this.steps[this.currentStepKey]?.key) {
        const nextStepKey = this.steps.findIndex(step => step.key === this.queryStringStep);
        if (nextStepKey >= 0 && nextStepKey !== this.currentStepKey) {
          this.activateStep(nextStepKey, false);
        }
      }
    });

    // If no type, redirect to landing page
    // If no type, redirect to landing page
    if (typeof this.steps === 'undefined' && !this.shouldStartAssistantFromUrl()) {
      this.router.navigate(['/form-landing'], { queryParams: !this.paramType ? { type: 'default' } : {}, queryParamsHandling: 'merge' });
    }

    // Load Tests for Angular page after the Matomo bootstrap has defined _paq/helpers.
    if (!this.removeTrackers) {
      this.loadMatomoTestsWhenReady();
    }

    // Init form
    // Alter form version for current experiment
    this.form = new UntypedFormGroup({});
    this.form.addControl('type', new UntypedFormControl(this.type));
    this.form.addControl('desiredLoanAmount', new UntypedFormControl(0));
    this.form.addControl('ltv', new UntypedFormControl(0));
    this.form.addControl('trustedFormUrl', new UntypedFormControl(''));
    this.form.addControl('experiment', new UntypedFormControl(''));
    this.form.addControl('experimentVariation', new UntypedFormControl(''));
    this.form.addControl('experimentData', new UntypedFormControl(''));
    this.form.addControl('jornayaLeadId', new UntypedFormControl(''));
    this.form.addControl('leadReferrer', new UntypedFormControl(this.leadReferrerService.leadReferrer));
    this.form.addControl('leadReferrerString', new UntypedFormControl(this.leadReferrerService.leadReferrerString));
    this.form.addControl('propertyState', new UntypedFormControl(''));
    this.form.addControl('propertyCity', new UntypedFormControl(''));
    this.form.addControl('pageType', new UntypedFormControl('v4-' + this.brandService.pageType));
    this.form.addControl('rate_finder_session_id', new UntypedFormControl(this.fruHttp.getRateFinderSessionId()));
    if (this.type === 'purchase') {
      this.form.addControl('daysFromBuying', new UntypedFormControl('no'));
      this.form.addControl('foundHome', new UntypedFormControl('no'));
      this.form.addControl('signedAgreement', new UntypedFormControl('no'));
    }
    this.form.addControl('formVersion', new UntypedFormControl('4'));
    this.form.addControl('rateType', new UntypedFormControl(''));

    this.form.addControl('clientId', new UntypedFormControl(''));
    this.best.lenderSubscribe.subscribe((clientId) => {
      this.form.controls.clientId.setValue(clientId);
    });

    this.form.addControl('position', new UntypedFormControl(''));
    this.best.clientPosition.subscribe((position) => {
      this.form.controls.position.setValue(position);
    });

    this.form.addControl('fruSource', new UntypedFormControl(''));
    this.best.clientFruSource.subscribe((fruSource) => {
      this.form.controls.fruSource.setValue(fruSource);
    })

    this.form.addControl('formType', new UntypedFormControl(this.formType));
    this.form.addControl('lp_button', new UntypedFormControl(this.lp_button));
    if (this.isReverseFlow()) {
      // FRU-24835: posts flow_type reverse, which the intake turns into product and lead type reverse. Reverse asks no cash
      // question, so cashOut is 0 and the loan amount the value and balance steps work out is the balance alone.
      this.form.addControl('flowType', new UntypedFormControl('reverse'));
      if (!this.form.contains('cashOut')) {
        this.form.addControl('cashOut', new UntypedFormControl(0));
      }
    }

    // if (this.isSelectedLeads$.getValue()) {
    this.isSelectedLeads$.subscribe(value => {
      if (value) {
        this.form.addControl('nsLeadId', new UntypedFormControl(''));
        this.form.addControl('lenders', new FormArray([]));
        this.form.addControl('lendersList', new FormArray([]));
        this.form.addControl('selected_tcpa', new UntypedFormControl('1'));
        this.form.addControl('selectedListSource', new UntypedFormControl('selected_manager'));
      }
    });

    this.form.addControl('preCashOut', new UntypedFormControl(this.cashOutAmount));

    // Save visitor actions. Is all default
    if (this.type === 'purchase') {
      this.form.addControl('newHomeValueAction', new UntypedFormControl('0'));
      this.form.addControl('estimatedDownPaymentAction', new UntypedFormControl('0'));
    } else if (this.type === 'refinance' && this.lp_button != 'personalloan') {
      this.form.addControl('cashOutAction', new UntypedFormControl('0'));
      this.form.addControl('propertyValueAction', new UntypedFormControl('0'));
      this.form.addControl('firstMortgageBalanceAction', new UntypedFormControl('0'));
    }

    this.communicationService.getShouldSetDefaultSelected().subscribe(
      (enable: boolean) => {
        if(enable && !this.notSubmitedLeadId) {
          this.setDefaultSelectedResponse('default_angular_no_response');
        }
      });

    let d = new Date();
    let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const nth = function(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return 'st';
        case 2:  return 'nd';
        case 3:  return 'rd';
        default: return 'th';
      }
    }
    const formatAMPM = function(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    // ex: June 15th at 7:26 pm
    this.currentDate = monthNames[d.getMonth()] +' '+ d.getDate() + nth(d.getDate());
    this.currentTime = formatAMPM(d);
    // IE accept 'default' only from EDGE versios
    //this.currentDate = d.toLocaleString('default', { month: 'numeric', day: 'numeric', year: 'numeric' });
    //this.currentTime = d.toLocaleString('default', { hour: 'numeric', minute: 'numeric' });

    // console.log(this.beState);
    if (this.brandService.view == 'best' && this.beState != '' && this.clientId == '22783') {
      // deepcode ignore Ssrf: this method is run from the browser, not the server
      this.fruHttp.getBEstatus(this.clientId, this.beState, this.type).subscribe(response => {
        if (response.status == 'success') {
          this.isBeEnabled$.next(response.enabled);
          if (response.enabled == false) {
            this.brandService.logoSrc = '/assets/images/logo.png';
            this.router.navigate(['/rates-form'], { queryParams: {l: 'fru'}, queryParamsHandling: 'merge' });
          }
        }
      });
    }

  }

  private primeEffectiveRateCache(): void {
    try {
      const qp = new URLSearchParams(window.location.search);
      // hopex review 8/13 (correct): this prime is gated on isDirectHopeEntry, so it is a HOPE
      // call site, not an original-form one. I had classified this whole file as original-form
      // when scoping the comparison policy, which left the prime asking for the EXACT equity
      // bucket while Hope's own components asked for the comparison bucket -- two competing
      // requests for one page, into a scoped cache. The policy belongs here too.
      const rateRequest = applyEquityComparisonPolicy(resolveEffectiveRateRequest({
        type: qp.get('type'),
        loanPurpose: qp.get('LoanPurpose') || qp.get('loanPurpose') || qp.get('loanpurpose'),
        formType: qp.get('FormType') || qp.get('formType'),
        lpButton: qp.get('lp_button'),
        pageType: (this.brandService && this.brandService.data && this.brandService.data.pageType) || '',
        program: (this.productPresentation && this.productPresentation.program) || '',
      }));
      const exactScopesEnabled = this.fruHttp.effectiveAdvertisedRatesEnabled();
      if (exactScopesEnabled && rateRequest.kind === 'invalid') {
        this.fruHttp.clearEffectiveAdvertisedRateScope();
        return;
      }
      const bucket = rateRequest.kind === 'scoped' ? rateRequest.bucket : undefined;
      this.fruHttp.getRateFinderRates(bucket || undefined).subscribe(() => { /* prime the scoped cache */ });
    } catch (e) { /* non-fatal */ }
  }

  ngAfterViewInit() {
    // For accessing the components themselves from here
    this.stepComponents = this.stepComponentList.toArray();
    if (!this.shouldStartAssistantFromUrl()) {
      this.recordFormStep(this.steps?.[this.currentStepKey]?.key || '');
    }
    // Original form: lift index.html's loading skeleton (#form-boot) once the first step is on screen. A no-op on Hope
    // Direct, which has no __formBootDone (its own card is lifted by the chat).
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      watchFormBoot(window, document, this.elementRef.nativeElement, () => this.formBootWatchStopped);
    }
    this.stepComponentList.changes.subscribe(() => {
      this.stepComponents = this.stepComponentList.toArray();
      // FRU-21436: step components register their form controls (email, phoneNumber, etc.) lazily in
      // their own ngOnInit, which can run AFTER activateStep() already called applySwitchBackSeed().
      // That race left the email/phone CONTROL empty on a "Switch Back" even though the native input
      // showed the value -> "Email is required" and Continue blocked. Re-apply the seed whenever the
      // rendered step set changes, so a control that only just appeared gets its carried value + revalidates.
      this.applySwitchBackSeed();
    });
    // Get the office status. FRU-21810 perf: its only consumer is the phone header, which is
    // hidden while Hope is active -- but a "Continue without AI" switch-back re-shows it, so for
    // direct-Hope entries DEFER the call out of the boot-critical window rather than dropping it
    // (measured 176ms occupying a connection slot in the 1.5-2.0s window). Classic entries: unchanged.
    let adnetwork = this.leadReferrerService.getAdnetwork();
    const fetchOfficeStatus = () => {
      try {
        this.fruHttp.getOfficeStatus(this.type == 'personalloan' ? 'DebtConsolidation' : adnetwork)
          .subscribe(officeStatus => this.applyOfficeStatus(officeStatus));
      } catch (e) { /* non-fatal */ }
    };
    if (this.assistantLaunchPending || this.showAssistant) {
      setTimeout(fetchOfficeStatus, 5000);
    } else {
      fetchOfficeStatus();
    }
  }

  private applyOfficeStatus(officeStatus: OfficeStatus): void {
    this.officeStatus = officeStatus;
    const assistant = this.assistantComponentRef;
    if (!assistant) { return; }
    assistant.instance.officeStatus = officeStatus;
    try { assistant.changeDetectorRef.detectChanges(); } catch (e) { /* non-fatal */ }
  }

  private loadMatomoTestsWhenReady(tries: number = 0): void {
    const matomoReady = !!(window as any)._paq && typeof (window as any).triggerAngularMatomoExperiment === 'function';
    if (matomoReady) {
      this.loadScripts.loadScript('/js/mm_include_tests.js?v=0.0.1');
      return;
    }

    if (tries >= 50) {
      console.warn('Matomo bootstrap did not load; skipping AB test include.');
      return;
    }

    setTimeout(() => this.loadMatomoTestsWhenReady(tries + 1), 100);
  }

  private rateFinderAction(action: string, step: string, value: any = '', meta: any = {}): ChatAction {
    this.rateFinderActionSeq += 1;
    return new ChatAction(action, step || '', value, '', {
      ...meta,
      event_seq: this.rateFinderActionSeq,
    });
  }

  private queueRateFinderAction(action: string, step: string, value: any = '', meta: any = {}): void {
    try {
      this.aiRateFinderChatService.queueAction(this.rateFinderAction(action, step, value, meta));
    } catch (e) { /* telemetry must never own the form */ }
  }

  private sendRateFinderTerminalAction(action: string, step: string, value: any = '', meta: any = {}): void {
    try {
      const terminalAction = this.rateFinderAction(action, step, value, meta);
      const threadId = this.aiRateFinderChatService.getCurrentThreadId();
      if (this.fruHttp.saveActionOnUnload(terminalAction, threadId || undefined)) { return; }
      this.aiRateFinderChatService.queueAction(terminalAction);
    } catch (e) { /* telemetry must never own the redirect */ }
  }

  // FRU-23258: Back can be the visitor leaving. Once a thread exists, send the Back action as a keepalive request straight away
  // instead of behind earlier actions still in the queue, so it is not lost when the page goes. Without a thread it is queued,
  // because the first queued answer carries the new thread id.
  private sendRateFinderBackAction(action: string, step: string, value: any = '', meta: any = {}): void {
    try {
      const backAction = this.rateFinderAction(action, step, value, meta);
      const threadId = this.aiRateFinderChatService.getCurrentThreadId();
      if (threadId && this.fruHttp.saveActionOnUnload(backAction, threadId)) { return; }
      this.aiRateFinderChatService.queueAction(backAction);
    } catch (e) { /* telemetry must never own browser navigation */ }
  }

  private recordFormStep(stepKey: string): void {
    if (!stepKey) { return; }
    this.queueRateFinderAction('step', stepKey, '', {
      arm: 'form',
      surface: 'classic_form',
      source: 'form',
    });
    this.analyticsService.trackFormStep(stepKey);
  }

  private formStepFieldNames(stepKey: string): string[] {
    if (!this.form || !this.form.controls) { return []; }
    const instance: any = this.stepComponents?.[this.currentStepKey]?.cmpRef?.instance;
    const ownedControls: any[] = [];
    if (instance?.control) { ownedControls.push(instance.control); }
    if (Array.isArray(instance?.controls)) { ownedControls.push(...instance.controls); }

    const names = Object.keys(this.form.controls).filter((name) => ownedControls.indexOf(this.form.controls[name]) >= 0);
    const extras: { [key: string]: string[] } = {
      cashOutReason: ['cashOutReasonDetail'],
      phone: ['sms', 'email_preference', 'prefers_spanish', 'prefers_digital'],
      neustar: ['sms', 'email_preference', 'prefers_spanish'],
    };
    (extras[stepKey] || []).forEach((name) => {
      if (this.form.controls[name] && names.indexOf(name) < 0) { names.push(name); }
    });
    if (!names.length && this.form.controls[stepKey]) { names.push(stepKey); }
    return names;
  }

  private safeCommittedValue(field: string, value: any): any {
    const sensitive = [
      'firstName', 'lastName', 'email', 'phone', 'phoneNumber', 'phone_number',
      'streetAddress', 'zipCode', 'cashOutReasonDetail',
    ];
    if (sensitive.indexOf(field) >= 0) {
      return value === null || value === undefined || value === '' ? '' : 'provided';
    }
    if (typeof value === 'string') { return value.slice(0, 80); }
    if (typeof value === 'number' || typeof value === 'boolean') { return value; }
    return value === null || value === undefined ? '' : 'committed';
  }

  private recordFormCommit(stepKey: string): void {
    if (!stepKey) { return; }
    const fields = this.formStepFieldNames(stepKey);
    const values: { [key: string]: any } = {};
    fields.forEach((field) => { values[field] = this.safeCommittedValue(field, this.form.controls[field]?.value); });
    const instance: any = this.stepComponents?.[this.currentStepKey]?.cmpRef?.instance;
    const source = Array.isArray(instance?.buttonList) ? 'button' : 'form_control';
    const analyticsValue = fields.length === 1 ? values[fields[0]] : 'committed';

    this.queueRateFinderAction('answer', stepKey, analyticsValue, {
      arm: 'form',
      surface: 'classic_form',
      source,
      raw_input: values,
      parsed_value: values,
      normalized_value: values,
      committed_fields: fields,
      validation_status: 'accepted',
      committed: true,
    });
    this.analyticsService.trackFormAnswer(stepKey, analyticsValue);
    // A carried assistant answer is not a new visitor action on the classic form.
    const hasNewAnswer = fields.some(field => !this.switchBackSeed
      || !Object.prototype.hasOwnProperty.call(this.switchBackSeed, field)
      || this.form.controls[field]?.value !== this.switchBackSeed[field]);
    if (fields.length && hasNewAnswer && fields.every(field => this.form.controls[field]?.valid)) {
      this.analyticsService.trackOpenaiCommittedAnswer(stepKey,
        fields.length === 1 ? this.form.controls[fields[0]]?.value : 'committed', {
          firstName: this.form.controls.firstName?.valid ? this.form.controls.firstName.value : undefined,
          lastName: this.form.controls.lastName?.valid ? this.form.controls.lastName.value : undefined,
        });
    }
  }

  private recordRateFinderModeSwitch(fromStep: string, direction: 'to_assistant' | 'to_form'): void {
    this.rateFinderFlipSeq += 1;
    this.queueRateFinderAction('mode_switch', fromStep, direction, {
      arm: direction === 'to_assistant' ? 'form' : 'assistant',
      surface: direction === 'to_assistant' ? 'classic_form' : 'ai_assistant',
      direction,
      from_step: fromStep,
      flip_seq: this.rateFinderFlipSeq,
    });
  }

  nextStep(stepKey?: number): void {
    // FRU-21800: isSubmitting was only ever used to disable the Next button in the
    // template -- a UI deterrent, not a guard on this function itself. A duplicate
    // stepEvent emission (double-click/double-tap, or any other double-trigger)
    // while the final submit is in flight could re-enter this whole function and
    // fire a second real submitLead() before the first one's response (and the
    // isSubmitting reset it does on the disabled button) ever lands. Nothing past
    // this point is ever meant to run again once the final submit has started.
    if (this.isSubmitting) {
      return;
    }
    const sentryFromIndex = this.currentStepKey;
    const sentryFromStep = this.steps?.[this.currentStepKey]?.key || '';
    // FAST mode (FRU-21170): when paused at a user-input step (zip / contact),
    // swallow the form's stray double-advance ("called twice" quirk) so FAST stops
    // there; a real user advance moments later resumes the auto-walk.
    if (typeof stepKey === 'undefined' && this.fastMode.enabled) {
      if (this.fastMode.justAutoStopped()) {
        return;
      }
      if (this.fastMode.paused) {
        this.fastMode.resume();
      }
    }
    const committedStep = this.steps?.[this.currentStepKey];
    const isForwardCommit = committedStep?.state === 'active'
      && (typeof stepKey === 'undefined' || stepKey > this.currentStepKey);
    if (isForwardCommit) { this.recordFormCommit(committedStep.key); }
    // Jornaya snapshot
    this.jornayaService.snap();

    // if (this.steps[this.currentStepKey].key == 'phone' && this.promptAllowed && !this.promptAsked) {
    //   // Check is featured selected
    //   let isFeaturedDeSelected = false;
    //   let isFeatured = false;
    //   let checkedList = [];
    //   this.form.value.lendersList.forEach(value => {
    //     if (value.featured && !value.checked) {
    //       isFeaturedDeSelected = true;
    //       this.featuredLender = value;
    //     }
    //     if (value.checked) {
    //       checkedList.push(value.id);
    //     }
    //     if (value.featured) {
    //       isFeatured = true;
    //       this.featuredLender = value;
    //     }
    //   });

    //   let isAllDeSelected = false;
    //   if (this.form.value.lendersList.length > 0 && checkedList.length == 0) {
    //     isAllDeSelected = true
    //   }

    //   if (isAllDeSelected || isFeatured) {
    //     if (isAllDeSelected) {
    //       this.promptType = 'all_deselected';
    //       this.promptText = 'Do you want to Get Rates from Rocket Mortgage?';
    //     } else {
    //       if (isFeaturedDeSelected) {
    //         this.promptType = 'featured_deselected';
    //         this.promptText = 'Do you also want to Get Rates from ' + this.featuredLender.bank_name + '?';
    //       } else {
    //         this.promptType = 'featured_selected';
    //         this.promptText = 'Are you sure you want to Get Rates from ' + this.featuredLender.bank_name + '?';
    //       }
    //     }
    //     this.showPrompt = true;
    //     this.isContinueRedirect$.next(false);
    //     this.promptAsked = true;
    //     window['_paq'].push(['trackGoal', 75]); // Track goal about display prompt

    //   }
    // }

    // Disappear current step
    this.steps[this.currentStepKey].state = 'inactive';

    if (this.steps[this.currentStepKey].key == 'firstNameLastName' && this.isSelectedLeads$.getValue()) {
      // Send request to create "Not Submitted" lead and get lenders
      let postLead = new PostLead(this.form.value);
      if (this.notSubmitedLeadId === 0) {
        this.fruHttp.saveNotSubmitedLead(postLead, this.isChecked).subscribe(response => {
          if (!this.cancelSelectedRequest) {
            this.availableSelected$.next(response);
            this.notSubmitedLeadId = response.lead_id;
            this.form.controls.nsLeadId.setValue(response.lead_id);
            const lenderArray: FormArray = this.form.get('lenders') as FormArray;
            const lenderList: FormArray = this.form.get('lendersList') as FormArray;
            if (response.lenders) {
              response.lenders.forEach(value => {
                if (value.checked) {
                  lenderArray.push(new UntypedFormControl(value?.id));
                }
                lenderList.push(new UntypedFormControl(value));
              });
            }
          }
        });

        this.fruHttp.getDefaultLenders(postLead, this.isChecked).subscribe(response => {
          this.defaultResponse = response;
        });
      } else {
        console.log('Not allow submit twice');
      }
    }

    if (this.steps[this.currentStepKey].key == 'firstNameLastName' && this.form.controls.propertyState.value == '') {
      this.fruHttp.getStateNew().subscribe(response => {
        this.stateByIp = response?.state ?? '';
        if (this.stateByIp != '') {
          this.form.controls.propertyState.setValue(this.stateByIp);
        }
      });
    }

    if (this.steps[this.currentStepKey].key == 'email') {
      let postLead = new PostLead(this.form.value);
      if (this.notSubmitedLeadId) {
        this.fruHttp.updateNotSubmitedLead(postLead).subscribe(response => {
          console.log('Success');
        });
        let lenders = this.availableSelected$.getValue();
        if (lenders.lenders.length == 0) {
          this.setDefaultSelectedResponse('default_angular_empty_response', lenders.lead_id);
        }
      } else if (this.form.contains('selectedListSource')) {
        // We submit email step but still have no response from selected_manager
        //this.setDefaultSelectedResponse('default_angular_no_response');
      }
      postLead.abandonment = true;
      this.fruHttp.submitLead(postLead).subscribe({ error: () => {} });
    }

    this.neustarTest = false;
    // Check if phone step
    // step key comes through as undefined pretty often, this way of checking works for undefined/null and numbers greater
    // than the current step key incase that is ever passed to next step
    if(this.steps[this.currentStepKey].key == 'phone' && this.neustarTest && !(stepKey < this.currentStepKey)) {
      // console.log('started neustar test');
      // // Set experimentData
      // this.form.controls.experimentData.setValue(this.experimentData);
      // // Get trusted form url
      // let trustedForm = this.elementRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
      // this.form.controls.trustedFormUrl.setValue((trustedForm !== null) ? trustedForm.value : null);

      // // Get jornaya leadid
      // let leadId = this.elementRef.nativeElement.querySelector('[name=universal_leadid]');
      // this.form.controls.jornayaLeadId.setValue((leadId !== null) ? leadId.value : null);

      // // PostLead will convert to what lead_manager is expecting from all forms
      // let postLead = new PostLead(this.form.value);

      // // Get Score
      // if(this.isSubmitting == false) { // stop spam submits
      //   this.isSubmitting = true;
      //   console.log('is submitting');
      //   this.fruHttp.submitLead(postLead).subscribe(response => {
      //     console.log('submitlead response: ');
      //     console.log(response);

      //     this.phoneScore = Number(response.phone_score);
      //     if(Number(response.reverify_phone) == 1) {
      //       // only re-enable submits if they move to the next step
      //       this.isSubmitting = false;
      //       console.log('phone score was under 21');
      //       // Find next step
      //       this.currentStepKey = typeof stepKey !== 'undefined' ? stepKey : this.currentStepKey + 1;

      //       // See if we have a next step to show
      //       if (typeof this.steps[this.currentStepKey] !== 'undefined') {
      //         // Check if next step has a requirement
      //         if (typeof this.steps[this.currentStepKey].require === 'function' && !this.steps[this.currentStepKey].require()) {
      //           this.nextStep();
      //           return;
      //         }

      //         // Run any functions that need to happen before displaying
      //         if (typeof this.steps[this.currentStepKey].beforeDisplay === 'function') {
      //           this.steps[this.currentStepKey].beforeDisplay();
      //         }
      //         //save history
      //         this.stepHistory.push(this.currentStepKey);
      //         // Activate step
      //         this.steps[this.currentStepKey].state = 'active';

      //         this.analyticsService.trackQuestionShown(this.steps[this.currentStepKey].key);

      //         // Change url
      //         this.router.navigate(['/rates-form'], { queryParams: { step: this.steps[this.currentStepKey].key }, queryParamsHandling: 'merge' });

      //         // Run custom function initStep on step
      //         this.stepComponents[this.currentStepKey].initStep();
      //       }
      //     } else {
      //       console.log('phone score was above 21, doing full submit');
      //       this.handleSubmit(response);
      //     }
      //   });
      // }
    } else { // not phone step and/or not neustar test active
      // Find next step
      const previousStepKey = this.currentStepKey;
      this.currentStepKey = typeof stepKey !== 'undefined' ? stepKey : this.currentStepKey + 1;
      // FRU-24782: forward, a second tap that follows belongs to the step that just left; Back (goBack() passes an earlier
      // step) clears the hold so a quick re-answer goes through.
      this.stepAdvancedAt = holdStampAfterStepChange(previousStepKey, this.currentStepKey, Date.now());

      // if (this.steps[this.currentStepKey]?.key == 'lendersCount' && !this.isLendersCount$.getValue()) {
      //   // Skip step, display it only for ab test
      //   this.nextStep();
      //   return;
      // }

      if (this.steps[this.currentStepKey]?.key == 'maximumEquity' && this.isCashOutSet) {
        this.nextStep();
        return;
      }

      // See if we have a next step to show
      if (typeof this.steps[this.currentStepKey] !== 'undefined') {
        if (this.steps[this.currentStepKey].key !== 'email' && this.steps[this.currentStepKey].key !== 'phone') {
          this.removeBackgroundImage();
        }
        //show text of disclosure on phone step if fruLocalKiosk
        this.leadDisclosure = (this.steps[this.currentStepKey].key == 'phone' && this.fruLocalKiosk) ?? false;
        // Check if next step has a requirement

        if (typeof this.steps[this.currentStepKey].require === 'function' && !this.steps[this.currentStepKey].require()) {
          this.nextStep();
          return;
        }

        // Run any functions that need to happen before displaying
        if (typeof this.steps[this.currentStepKey].beforeDisplay === 'function') {
          this.steps[this.currentStepKey].beforeDisplay();
        }
        //save history
        this.stepHistory.push(this.currentStepKey);
        // Activate step
        this.steps[this.currentStepKey].state = 'active';

        const sentryToStep = this.steps[this.currentStepKey].key;
        updateRateFinderSentryContext({ mode: 'form', step: sentryToStep });
        addRateFinderBreadcrumb(
          typeof stepKey !== 'undefined' && stepKey < sentryFromIndex ? 'step_regression' : 'step_advance',
          {
            from_step: sentryFromStep,
            to_step: sentryToStep,
            mode: 'form',
          }
        );

        this.analyticsService.trackQuestionShown(this.steps[this.currentStepKey].key);
        this.recordFormStep(this.steps[this.currentStepKey].key);


        // Change url
        this.router.navigate(['/rates-form'], { queryParams: { step: this.steps[this.currentStepKey].key }, queryParamsHandling: 'merge' });
        // Run custom function initStep on step
        this.stepComponents[this.currentStepKey].initStep();

      } else { // no next step to show

        // Set experimentData
        this.includeLandingAiBoxExperimentData();
        this.mergeExperimentCookieTruth();  // FRU-21478 cookie recovery; FRU-21535 binds Hope-Direct to the current server URL arm
        this.form.controls.experimentData.setValue(this.experimentData);
        // Get trusted form url
        let trustedForm = this.elementRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
        this.form.controls.trustedFormUrl.setValue((trustedForm !== null) ? trustedForm.value : null);

        // Get jornaya leadid
        let leadId = this.elementRef.nativeElement.querySelector('[name=universal_leadid]');
        this.form.controls.jornayaLeadId.setValue((leadId !== null) ? leadId.value : null);

        if (this.isFastModeAllowed) {
          ['propertyValueAction', 'cashOutAction', 'firstMortgageBalanceAction'].forEach((controlName) => {
            if (this.form.controls[controlName]) {
              this.form.controls[controlName].setValue('1');
            } else {
              this.form.addControl(controlName, new UntypedFormControl('1'));
            }
          });
          if (this.hasFastModeBeenEnabled) {
            if (!this.form.controls.leadFastMode) {
              this.form.addControl('leadFastMode', new UntypedFormControl('1'));
            } else {
              this.form.controls.leadFastMode.setValue('1');
            }
            if (!this.form.controls.fastModeEnabledStep) {
              this.form.addControl('fastModeEnabledStep', new UntypedFormControl(this.fastModeEnabledStep));
            } else {
              this.form.controls.fastModeEnabledStep.setValue(this.fastModeEnabledStep);
            }
          }
        }

        if (this.hasAIModeBeenEnabled) {
          this.setFormControlValue('leadAIMode', '1');
        }

        // FRU-24835: a reverse lead goes out only when both eligibility answers qualify; otherwise back to that question.
        const reverseGate = this.reverseGateStep(this.steps.length);
        if (reverseGate !== null) {
          this.activateStep(reverseGate);
          return;
        }

        // PostLead will convert to what lead_manager is expecting from all forms
        let postLead = new PostLead(this.form.value);

        // Submit form
        this.isSubmitting = true;

        updateRateFinderSentryContext({ mode: 'form', step: 'submit' });
        addRateFinderBreadcrumb('submit_attempt', { from_step: sentryFromStep, mode: 'form' });
        this.queueRateFinderAction('submit_attempt', 'submit', '', { arm: 'form', surface: 'classic_form' });
        this.analyticsService.trackRateFinderSubmitState('form', 'attempt');
        this.analyticsService.trackFinalSubmit('form');

        const submittedEmail = postLead.email;
        try { this.analyticsService.prepareOpenaiSubmission(submittedEmail); } catch (_) { /* Non-fatal. */ }

        this.fruHttp.submitLead(postLead)
          .subscribe(response => {
            updateRateFinderSentryContext({ lead_id: (response && response.lead_id) as any });
            addRateFinderBreadcrumb('submit_success', { outcome: response && response.status, mode: 'form' });
            const responseStatus = (response?.status || '').toString().trim().toLowerCase();
            const durableReceipt = !!(response?.lead_id && response?.product)
              && ['error', 'failed', 'rejected'].indexOf(responseStatus) < 0;
            const submitState = durableReceipt ? 'success' : 'failure';
            this.sendRateFinderTerminalAction('submit_' + submitState, 'submit', response?.status || '', {
              arm: 'form',
              surface: 'classic_form',
              status: response?.status || '',
              durable_receipt: durableReceipt,
            });
            this.analyticsService.trackRateFinderSubmitState('form', submitState, {
              status: response?.status || '',
              durable_receipt: durableReceipt,
            });
            if (durableReceipt && responseStatus !== 'duplicate') {
              this.analyticsService.trackOpenaiAcceptedSubmission(response.lead_id, submittedEmail);
            }
            this.handleSubmit(response);
          }, error => {
            this.queueRateFinderAction('submit_failure', 'submit', '', {
              arm: 'form',
              surface: 'classic_form',
              http_status: error?.status || 0,
            });
            this.analyticsService.trackRateFinderSubmitState('form', 'failure', { http_status: error?.status || 0 });
            console.error('Lead submit failed', error);
            captureRateFinderException(error, 'submit_failure', {
              http_status: error && error.status,
              mode: 'form',
            });
            this.isSubmitting = false;
            // FRU-21559 (capture-first): never dump a completed consumer to the offers page, even on a
            // hard submit error. Route through handleSubmit with an empty response -> thank-you (dc=1, so
            // no conversion fires). Their details are captured; a hollow offers page just loses the lead.
            this.handleSubmit({dc: 1} as any);
          });
      }
    }
  }

  private activateStep(stepKey: number, updateUrl: boolean = true): void {
    if (!this.steps || !this.steps[stepKey]) {
      return;
    }
    const reverseGate = this.reverseGateStep(stepKey);
    if (reverseGate !== null) {
      stepKey = reverseGate;
    }

    this.steps.forEach(step => step.state = 'inactive');
    const previousStepKey = this.currentStepKey;
    this.currentStepKey = stepKey;
    // FRU-24782: browser Back lands here via the route subscription; going to an earlier step ends any hold so a quick
    // re-answer on the returned question goes through. Forward transitions keep the existing hold untouched.
    if (stepKey < previousStepKey) {
      this.stepAdvancedAt = 0;
    }
    if (this.steps[this.currentStepKey].key !== 'email' && this.steps[this.currentStepKey].key !== 'phone') {
      this.removeBackgroundImage();
    }
    this.steps[this.currentStepKey].state = 'active';
    updateRateFinderSentryContext({ mode: 'form', step: this.steps[this.currentStepKey].key });

    if (!updateUrl && this.stepHistory.indexOf(this.currentStepKey) >= 0) {
      this.stepHistory = this.stepHistory.slice(0, this.stepHistory.lastIndexOf(this.currentStepKey) + 1);
    } else if (!this.stepHistory.length || this.stepHistory[this.stepHistory.length - 1] !== this.currentStepKey) {
      this.stepHistory.push(this.currentStepKey);
    }

    this.analyticsService.trackQuestionShown(this.steps[this.currentStepKey].key);
    this.recordFormStep(this.steps[this.currentStepKey].key);
    if (updateUrl) {
      this.router.navigate(['/rates-form'], { queryParams: { step: this.steps[this.currentStepKey].key }, queryParamsHandling: 'merge' });
    }

    setTimeout(() => {
      if (typeof this.steps[this.currentStepKey].beforeDisplay === 'function') {
        this.steps[this.currentStepKey].beforeDisplay();
      }
      if (this.stepComponents && this.stepComponents[this.currentStepKey]) {
        this.stepComponents[this.currentStepKey].initStep();
      }
      // FRU-21436: the step component just registered its controls (empty). If we are resuming from a
      // chat "Switch Back", (re)apply the carried answers + revalidate so they are not blank/invalid.
      this.applySwitchBackSeed();
    }, 0);
  }

  // continueWith(answer = 'no') {
  //   this.promptAsked = true;
  //   this.showPrompt = false;

  //   if (window['siteId'] == 1) {
  //     if (answer == 'no') {
  //       window['_paq'].push(['trackGoal', 74]);
  //     } else {
  //       window['_paq'].push(['trackGoal', 73]);
  //     }
  //   }

  //   // if (answer == 'no') {
  //   //   this.isContinueRedirect$.next(true);
  //   // } else {
  //     if (this.promptType == 'featured_deselected') {
  //       this.fruHttp.setRocketPromptAnswer(this.featuredLender.id, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     } else if (this.promptType == 'featured_selected') {
  //       this.fruHttp.setRocketPromptAnswer(this.featuredLender.id, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     } else {
  //       this.fruHttp.setAllPromptAnswer(this.form.value.lendersList, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     }
  //   // }
  // }

  getSubmitLead(): Lead {
    let cashOut = 0;
    let desiredLoanAmount = this.form.value.desiredLoanAmount ?? 0;
    if (this.form.value.cashOut && this.form.controls.maximumEquity) {
      cashOut = this.form.controls.maximumEquity.value == 'yes' && this.form.value.cashOut < 1000
        ? this.form.value.propertyValue * 0.9 - this.form.value.firstMortgageBalance
        : this.form.value.cashOut;
    }

    return {
      type: this.type,
      propertyState: this.form.controls.propertyState.value,
      cashOut: cashOut,
      desiredLoanAmount: desiredLoanAmount,
      creditRating: this.form.controls.creditRating.value,
    };
  }

  handleSubmit(response: FormResponse) {
    // this.isContinueRedirect$.subscribe(value => {
    //   if (value) {
        const lead: Lead = this.getSubmitLead();

        // FRU-21559 (capture-first): completed consumer + null status (same-day dup / soft validation,
        // backend responded 200) goes to thank-you, never the offers page. dc=1 -> no conversion fires.
        if (!response?.status) {
          this.fruHttp.redirectThankYou(lead, response, this.fruLocalKiosk);
          return;
        }

        switch (response.status) {
          case 'New':
          case 'Sent':
          case 'Block':
          case 'Review':
          case 'Not Sendable':
            // Go to thank you page
            let qr = this.fruLocalKiosk;
            this.fruHttp.redirectThankYou(lead, response, qr);
            break;

          default:
            // Go to offers page
            this.fruHttp.redirectOffers(lead);
            break;
        }
      // }
    // })

    // const lead: Lead = {
    //   type: this.type,
    //   propertyState: this.form.controls.propertyState.value,
    //   cashOut: cashOut,
    //   desiredLoanAmount: desiredLoanAmount,
    //   creditRating: this.form.controls.creditRating.value,
    // };

    // if (!response.status) {
    //   this.fruHttp.redirectOffers(lead);
    //   return;
    // }

    // switch (response.status) {
    //   case 'New':
    //   case 'Sent':
    //   case 'Block':
    //   case 'Review':
    //   case 'Not Sendable':
    //     // Go to thank you page
    //     let qr = this.fruLocalKiosk;
    //     this.fruHttp.redirectThankYou(lead, response, qr);
    //     break;

    //   default:
    //     // Go to offers page
    //     this.fruHttp.redirectOffers(lead);
    //     break;
    // }
  }

  isNotDebtType() {
    const formTypeParam = String(this.formType ?? this.route.snapshot.queryParams['FormType'] ?? '').toLowerCase();
    const typeParam = String(this.paramType ?? this.route.snapshot.queryParams['type'] ?? '').toLowerCase();
    const isDebtTypeParam = /debt-relief|debt-consolidation-loan|debt-settlement/i.test(typeParam);
    const isDebtFormType = /debtsettlement|debtrelief/i.test(formTypeParam);

    return !(isDebtTypeParam || isDebtFormType);
  }

  setBackgroundImage() {
    if (!this.removeBackgroundPhoneEmailStep && !this.fruLocal) {
      // Add lender rates background image
      let ratesForm = this.elementRef.nativeElement.querySelector('#rates-form form');
      if (ratesForm) {
        this.renderer.addClass(ratesForm, 'lender-rates-background');
      }
      
      //show secure form and go back button
      let secureForm = this.elementRef.nativeElement.querySelector(".secure_form:not(.fru21526-secure-badge)");
      if (secureForm) {
        this.renderer.addClass(secureForm, 'over_background');
      }
      if (this.currentStepKey > 0) {
        let goBackArrow = this.elementRef.nativeElement.querySelector(".go-back-arrow");
        if (goBackArrow) {
          this.renderer.addClass(goBackArrow, 'over_background');
        }
      }
      // Lighten modal background color
      let modal = this.elementRef.nativeElement.querySelector('#form-modal');
      if (modal) {
        this.renderer.addClass(modal, 'is-active');
      }
    }
  }

  removeBackgroundImage() {
    let ratesForm = this.elementRef.nativeElement.querySelector('#rates-form form');
    if (ratesForm) {
      this.renderer.removeClass(ratesForm, 'lender-rates-background');
    }

    let secureForm = this.elementRef.nativeElement.querySelector(".secure_form:not(.fru21526-secure-badge)");
    if (secureForm) {
      this.renderer.removeClass(secureForm, 'over_background');
    }

    let goBackArrow = this.elementRef.nativeElement.querySelector(".go-back-arrow");
    if (goBackArrow) {
      this.renderer.removeClass(goBackArrow, 'over_background');
    }

    let modal = this.elementRef.nativeElement.querySelector('#form-modal');
    if (modal) {
      this.renderer.removeClass(modal, 'is-active');
    }
  }

  // Ed 7/8: visible build stamp (runtime chunk hash) in the AI footer — instantly tells us whether a
  // phone tab is running the current bundle (stale-tab confusion cost hours repeatedly).
  private _hopeBuildTag = '';
  get hopeBuildTag(): string {
    if (this._hopeBuildTag) { return this._hopeBuildTag; }
    try {
      const sc = document.querySelector('script[src*="runtime."]');
      const m = sc && (sc.getAttribute('src') || '').match(/runtime\.([a-f0-9]{8})/);
      this._hopeBuildTag = m ? 'build ' + m[1] : ' ';
    } catch (e) { this._hopeBuildTag = ' '; }
    return this._hopeBuildTag;
  }

  adDisclosurePopup() {
    // The parent component also owns disclosure links for the original form.
    // Opt into the reviewed context only inside Hope or once this form has an
    // exact effective claim; every other shared caller keeps its legacy URL.
    this.fruHttp.adDisclosurePopup(
      this.showAssistant || this.fruHttp.hasCurrentEffectiveAdvertisedRate(),
    );
  }

  /** FRU-24540: the same address adDisclosurePopup() opens, as an href, so the footer item is a
   *  real link a keyboard user, crawler or ad reviewer can follow instead of a click-only anchor. */
  adDisclosureHref(): string {
    return this.fruHttp.adDisclosureUrl(
      this.showAssistant || this.fruHttp.hasCurrentEffectiveAdvertisedRate(),
    );
  }

  /** Keep the popup on plain activation (and its goal), while the href stands on its own for
   *  anyone who wants the link itself: a modified click (open in new tab / window) is left to the
   *  browser, as is keyboard activation and no-JS. */
  adDisclosureClick(event: MouseEvent): void {
    // detail 0 is a synthesized click (keyboard activation of the focused link): leave it to the
    // href. A modified click (open in new tab / window) and a non-left button are the href's too.
    if (event.detail === 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    this.adDisclosurePopup();
  }

  licensingDisclosurePopup() {
    this.fruHttp.licensingDisclosurePopup();
  }


  // Just in case we want this later, this is a thing
  stepAnimationDone() {
    var ratesform = document.getElementById('rates-form');
    if(ratesform && !this.fruLocal) {
      // Property type step, phones: the sticky header's height varies (call card, Ask Hope pill, branded logo), so a
      // fixed scroll-margin-top left the step content under it. Hand the real height to the CSS (styles.scss).
      const header = document.querySelector('header');
      if (this.onPropertyTypeStep && header) {
        ratesform.style.setProperty('--rates-form-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      } else {
        ratesform.style.removeProperty('--rates-form-header-height');
      }
      ratesform.scrollIntoView();
      // FRU-25273: that scroll can undo the step's own (the ZIP step lifts Continue above an open keyboard)
      const instance: any = this.stepComponents?.[this.currentStepKey]?.cmpRef?.instance;
      if (instance && typeof instance.afterFormScroll === 'function') {
        instance.afterFormScroll();
      }
    }
  }
  
  goBack(): void {
    if (!this.currentStepKey || this.stepHistory.length < 2) {
      return;
    }

    this.stepHistory.pop(); //drop current step from history
    let nextStepKey = this.stepHistory.pop(); //pull previous step from history and set to next step
    let prevStep = this.steps[nextStepKey];

    // cashOut auto redirect to cashOutReason, so go 2 steps back
    if (prevStep?.key == 'cashOut' && this.steps[this.currentStepKey]?.key ==='cashOutReason') {
      this.form.controls.maximumEquity.setValue(null);
      nextStepKey = this.stepHistory.pop();
    } else if (prevStep?.key == 'cashOut' && this.steps[this.currentStepKey]?.key ==='propertyValue') {
      // For rm max home equity test we may need to go back 2 steps from here as well
      nextStepKey = this.stepHistory.pop();
    }

    if (this.communicationService.maxCashoutForm
      && this.steps[nextStepKey].key === 'maximumEquity'
      && this.steps[this.currentStepKey].key === 'cashOutReason') {
      nextStepKey = this.stepHistory.pop();
    }

    //this.analyticsService.trackGoal(23); /** @ToDo create new goal if reruning test */
    this.nextStep(nextStepKey);
  }

  toggleModal(): void {
    this.showModal = !this.showModal;
  }

  redirectToStartOver() {
    window.location.href = '/communication/form-landing/local' + window.location.search;
  }

  propertyTypeConfirmation() {
    return this.form.controls.propertyType.value === 'Mobile';
  }

  maximumEquity() {
    return this.form.value.maximumEquity !== 'yes';
  }

  // showCashOut() {
  //   return this.form.value.maximumEquity !== 'yes';
  // }

  cashOutReason() {
    return (this.form.controls.cashOut.value > 0 || this.form.value.maximumEquity === "yes")
      && (this.formType != "homeimprovement");
  }

  private hasZeroMortgageBalance(): boolean {
    const v = this.form.controls.firstMortgageBalance?.value;
    return v !== '' && v !== null && v !== undefined && Number(v) === 0;
  }

  currentFHA() {
    if (this.hasZeroMortgageBalance()) {
      this.form.controls.currentFHA?.setValue('no');
      this.form.controls.currentVA?.setValue('no');

      return false
    }

    return true;
  }

  currentVA() {
    if (this.hasZeroMortgageBalance()) {
      this.form.controls.currentVA?.setValue('no');

      return false
    }

    return this.form.controls.veteranMilitary.value === 'yes';
  }

  neustar() {
    return this.neustarTest;
  }

  bankruptcyRecency() {
    return this.form.controls.bankruptcy.value !== 'no';
  }

  propertyStatus() {
    return this.form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief';
  }

  housingSituationIsOwn() {
    return this.form.controls.housingSituation.value === 'Own';
  }

  /** FRU-24835: a reverse mortgage request (LoanPurpose=refinance&FormType=reverse). Read from the URL, since the steps are
   *  built in the constructor, before ngOnInit copies FormType onto the component; the same two parameters ngOnInit reads. */
  isReverseFlow(): boolean {
    return isReverseQuery(this.route?.snapshot?.queryParams || {});
  }

  /** FRU-24835: in the reverse flow, the eligibility question before `target` whose answer doesn't qualify (age 62+, then the
   *  home as primary residence), or null. Forward, a URL step and the final submit all go back there instead. */
  private reverseGateStep(target: number): number | null {
    if (!this.isReverseFlow() || !this.steps) {
      return null;
    }
    // A deep link can ask for a later step before ngOnInit builds the form; with no answers yet, that goes to the age question.
    const ageKey = this.steps.findIndex(step => step.key === 'reverseAge');
    if (ageKey >= 0 && target > ageKey && this.form?.get('aged_sixty_two')?.value !== 'yes') {
      return ageKey;
    }
    const residenceKey = this.steps.findIndex(step => step.key === 'reverseResidence');
    if (residenceKey >= 0 && target > residenceKey && this.form?.get('propertyUse')?.value !== 'primary') {
      return residenceKey;
    }
    return null;
  }

  private isDscrInvestmentFlow(): boolean {
    const scalar = (value: any) => Array.isArray(value) ? (value[0] || '') : value;
    const raw = this.route.snapshot.queryParams['FormType'] || this.formType || '';
    const marker = String(scalar(raw)).toLowerCase();
    const button = String(scalar(this.route.snapshot.queryParams['lp_button'] || this.lp_button || '')).toLowerCase();
    // Constructor assistant/FAST gates run before initializeSteps assigns loanPurpose.
    // Keep the same mortgage-only boundary, including the personal-loan exclusion.
    const purpose = String(scalar(this.loanPurpose || this.route.snapshot.queryParams['LoanPurpose']
      || this.route.snapshot.queryParams['loanpurpose'] || '')).toLowerCase();
    return marker === 'dscr' && ['refinance', 'purchase'].includes(purpose) && button !== 'personalloan';
  }

  initializeSteps(preserveCurrentStep: boolean = false, loanPurposeOverride: string | null = null, lpButtonOverride: string | null = null) {
    const currentStep = preserveCurrentStep ? this.steps?.[this.currentStepKey]?.key : null;
    const currentHistory = preserveCurrentStep && Array.isArray(this.stepHistory)
      ? this.stepHistory.map(stepKey => this.steps?.[stepKey]?.key).filter(stepKey => !!stepKey)
      : [];

    const loanPurposeRaw = loanPurposeOverride || this.route.snapshot.queryParams['LoanPurpose'] || this.route.snapshot.queryParams['loanpurpose'] || '';
    this.loanPurpose = typeof loanPurposeRaw === 'object' ? loanPurposeRaw[0].toLowerCase() : loanPurposeRaw.toLowerCase();
    if (['refinance', 'purchase', 'personalloan'].indexOf(this.loanPurpose) < 0) return;

    const lpButton = lpButtonOverride || this.route.snapshot.queryParams['lp_button'] || this.route.snapshot.queryParams['lp_button'] || '';
    const lp_button = typeof lpButton === 'object' ? lpButton[0].toLowerCase() : lpButton.toLowerCase();
    let loanPurpose = this.loanPurpose;

    if (lp_button == 'personalloan') {
      loanPurpose = 'pl';
    }
    // FRU-24835: a reverse mortgage request is a refinance lead with flow_type reverse; it gets its own steps.
    if (this.isReverseFlow()) {
      loanPurpose = 'reverse';
    }

    // FRU-24300: keep ordinary require/product routing, but never FAST answers.
    // Property use must be the consumer's answer, not an investor preset or FAST guess.
    const dscrManualOnly = this.isDscrInvestmentFlow();
    if (dscrManualOnly) { this.isFullFastFlow = false; }
    this.steps = this.stepsService.getSteps(loanPurpose, this.isFullFastFlow).map(step => {
      // Resolve component classes from strings
      if (this.componentMappings[step.key]) {
        step.component = this.componentMappings[step.key];
      }
      // DSCR-only presentation. Ordinary steps, answers, validation and tracking stay unchanged.
      if (dscrManualOnly && step.key === 'propertyUse') {
        step.component = DscrPropertyUseComponent;
      } else if (dscrManualOnly && loanPurpose === 'purchase' && step.key === 'estimatedDownPayment') {
        step.component = DscrEstimatedDownPaymentComponent;
      }
      // Bind methods if specified
      if (step.beforeDisplay && typeof this[step.beforeDisplay] === 'function') {
        step.beforeDisplay = this[step.beforeDisplay].bind(this);
      }
      if (step.require && typeof this[step.require] === 'function') {
        step.require = this[step.require].bind(this);
      }

      return step;
    });

    if (preserveCurrentStep) {
      this.steps.forEach(step => step.state = 'inactive');
      const nextCurrentStepKey = this.steps.findIndex(step => step.key === currentStep);
      this.currentStepKey = nextCurrentStepKey >= 0 ? nextCurrentStepKey : Math.min(this.currentStepKey, this.steps.length - 1);
      this.steps[this.currentStepKey]['state'] = 'active';
      this.stepHistory = currentHistory
        .map(stepKey => this.steps.findIndex(step => step.key === stepKey))
        .filter(stepKey => stepKey >= 0);
      if (!this.stepHistory.length || this.stepHistory[this.stepHistory.length - 1] !== this.currentStepKey) {
        this.stepHistory.push(this.currentStepKey);
      }
    } else {
      this.steps[0]['state'] = 'active';
    }

    // FAST mode (FRU-21170): variation visitors may see the form toggle, but
    // auto-advance starts only after explicit landing opt-in via auto_mode=yes.
    const fastQuery = fastModeFromQuery(this.route.snapshot.queryParams);   // FRU-24835: never in the reverse flow
    const isFastAutoMode = !dscrManualOnly && fastQuery.auto;   // FRU-24300: never in the DSCR flow either
    this.isFastModeAllowed = !dscrManualOnly && fastQuery.allowed;
    if (isFastAutoMode) {
      this.fastMode.enable();
      this.hasFastModeBeenEnabled = true;
      this.fastModeEnabledStep = this.route.snapshot.queryParams['fast_mode_enabled_step'] || 'landing';
    } else if (this.fastMode.enabled) {
      this.fastMode.disable();
    }
    if (isFastAutoMode && this.fastMode.enabled) {
      // Derive smarter-than-default answers from the signals on the page.
      const snap = this.route.snapshot.queryParams;
      const keyword = (this.leadReferrerService.leadReferrer && this.leadReferrerService.leadReferrer.keyword)
        || snap['utm_keyword'] || snap['utm_term'] || snap['q'] || '';
      this.fastMode.computeOverrides({
        keyword: keyword,
        loanType: snap['LoanPurpose'] || snap['loanpurpose'] || '',
        formType: snap['FormType'] || ''
      });
      // Calculator carry-in (FRU calc-skin): if the consumer used the home-equity
      // calculator on the landing, they already gave us real home value + mortgage
      // balance. Feed those exact numbers into FAST as overrides so the matching
      // steps auto-advance with the CONSUMER'S OWN figures (not zip-median guesses).
      this.applyCalcOverrides(snap);
      setTimeout(() => {
        if (this.stepComponents && this.stepComponents[0]) {
          this.stepComponents[0].initStep();
        }
      }, 700);
    }

    // FRU-21130: the first step is activated here without a nextStep()/navigate, so it never
    // emits step=<key>. trackUrlChange() only fires a Matomo pageview when the URL changes, so
    // the first question is invisible to Matomo + GA4 today. Emit it once, mirroring nextStep(),
    // using replaceUrl so we do not add a browser-history entry.
    if (!preserveCurrentStep) {
      this.analyticsService.trackQuestionShown(this.steps[0].key); // not do anything at this moment
      this.router.navigate(['/rates-form'], {
        queryParams: { step: this.steps[0].key },
        queryParamsHandling: 'merge',
        // The document-initial fragment is part of a Direct-Hope retry's exact handoff URL.
        // Preserve it only on that entry path; Original keeps its existing URL behavior.
        preserveFragment: this.shouldStartAssistantFromUrl(),
        replaceUrl: true,
      });
    }
  }

  /**
   * Calculator carry-in: pull the home value + mortgage balance the consumer
   * entered in the landing calculator (sessionStorage 'fruCalc', with URL-param
   * fallback) and register them as FAST overrides for the dollar steps, so FAST
   * fills those questions with real numbers instead of the zip-median defaults.
   */
  private applyCalcOverrides(snap: any): void {
    let hv = 0;
    let bal = 0;
    try {
      const raw = sessionStorage.getItem('fruCalc');
      if (raw) {
        const c = JSON.parse(raw);
        hv = Number(c && c.homeValue) || 0;
        bal = Number(c && c.mortgageBalance) || 0;
      }
    } catch (e) { /* sessionStorage unavailable / bad JSON -> fall through to params */ }
    if (!hv) { hv = Number(snap && (snap['calcHomeValue'] || snap['homeValue'])) || 0; }
    if (!bal) { bal = Number(snap && (snap['calcBalance'] || snap['mortgageBalance'])) || 0; }
    if (hv > 0) {
      this.fastMode.setOverride('propertyValue', hv);
      this.fastMode.setOverride('newHomeValue', hv);
    }
    if (bal > 0) {
      this.fastMode.setOverride('firstMortgageBalance', bal);
    }
  }

  /**
   * Persistent FAST toggle present on every step (FRU-21170). Enabling mid-flow
   * resumes the auto-walk from the current step; tapping it off = "take the wheel".
   */
  toggleFast(): void {
    if (this.isDscrInvestmentFlow() || !this.isFastModeAllowed) {
      return;
    }

    if (this.fastMode.enabled) {
      this.fastMode.disable();
    } else {
      this.fastMode.enable();
      this.hasFastModeBeenEnabled = true;
      this.fastModeEnabledStep = this.fastModeEnabledStep || this.steps[this.currentStepKey]?.key || 'unknown';
      window['_paq'].push(['trackGoal', 138]);
      this.fastMode.computeOverrides({
        keyword: (this.leadReferrerService.leadReferrer && this.leadReferrerService.leadReferrer.keyword) || '',
        loanType: this.route.snapshot.queryParams['LoanPurpose'] || '',
        formType: this.route.snapshot.queryParams['FormType'] || ''
      });
      setTimeout(() => {
        if (this.stepComponents && this.stepComponents[this.currentStepKey]) {
          this.stepComponents[this.currentStepKey].initStep();
        }
      }, 150);
    }
  }

  showExitIntentPopup () {
    this.userExiting = true;
    this.hasSeenPopup = true;
  }

  closeExitIntentPopup () {
    this.analyticsService.trackGoal(19);
    this.userExiting = false;
  }

  get showPoweredByHeader(): boolean {
    return this.brandService.view === 'fru'
      && ['homeequitychoice.com', 'besthomeequityloan.com'].includes(this.brandService.domain);
  }

  get showFruLogoHeader(): boolean {
    return this.brandService.view === 'fru'
      && this.brandService.domain === 'freerateupdate.com';
  }

  get showBrandHeader(): boolean {
    return this.showPoweredByHeader || this.showFruLogoHeader;
  }

  get useLrfBrandedHeader(): boolean {
    return this.showPoweredByHeader && (this.showAiAssistantSwitch || this.showAssistant);
  }

  private shouldStartAssistantFromUrl(): boolean {
    if (this.isDscrInvestmentFlow() || typeof window === "undefined") { return false; }
    return /[?&]startAssistant=(1|yes|true)/i.test(window.location.search);
  }

  private shouldSwitchAssistantBackToLanding(): boolean {
    return false;
  }

  private mapFormStepToAssistantStep(stepKey: string | null): string | null {
    if (!stepKey) { return null; }
    const formToChatStep: { [key: string]: string } = {
      zipCodeStreetAddress: 'zipCode',
      firstNameLastName: 'firstName',
    };
    return formToChatStep[stepKey] || stepKey;
  }

  private syncAssistantExperimentFromUrl(): void {
    if (typeof window === "undefined") { return; }
    if (this.isDscrInvestmentFlow() || this.assistantLoadFailed) {
      this.aiAssistantEnabled = false;
      this.showAiAssistantSwitch = false;
      this.assistantLaunchPending = false;
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const startAssistant = params.get('startAssistant');
    // Calculator arm carry-in: a visitor who came through the home-equity calculator
    // (calc=homeequity / calcSkin) should get the assistant SWITCH on every form step,
    // like startAssistant=0, even though the calc redirect only carries auto_mode=yes.
    const fromCalc = this.calcSkin || params.get('calc') === 'homeequity';
    this.aiAssistantEnabled = startAssistant === '0' || startAssistant === '1' || fromCalc;
    this.showAiAssistantSwitch = startAssistant === '0' || fromCalc;   // Ed 7/11 V6: no per-form Ask Hope pill / taller header on the =1 (tile opt-in) flow -- keep the form identical to the original
    // Preserve the cold-entry latch across auto-start's scheduled callback and lazy import.
    // URL refreshes may cancel it, but must not arm it on an interactive Classic-to-Hope switch.
    this.assistantLaunchPending = this.assistantLaunchPending && startAssistant === '1' && !this.showAssistant;
  }

  private readLandingAssistantQuestion(): string | null {
    if (typeof window === "undefined") { return null; }
    try {
      const question = window.sessionStorage.getItem('fru21526LandingQuestion');
      return question && question.trim() ? question.trim() : null;
    } catch (e) {
      return null;
    }
  }

  private commitAssistantHandoffState(): void {
    if (typeof window === "undefined") { return; }
    try {
      window.sessionStorage.removeItem('fru21526LandingQuestion');
      window.sessionStorage.removeItem('fru21526AssistantIntent');
      window.sessionStorage.removeItem('fru21526CashoutAmount');

      const rawContext = window.sessionStorage.getItem('fru21526AiLandingContext');
      if (rawContext) {
        const context = JSON.parse(rawContext) || {};
        if (context.assumed) {
          delete context.assumed;
          window.sessionStorage.setItem('fru21526AiLandingContext', JSON.stringify(context));
        }
      }
    } catch (e) { /* handoff cleanup is non-fatal */ }
  }

  private hasLandingAssistantHandoff(): boolean {
    if (typeof window === "undefined") { return false; }
    try {
      return !!(
        window.sessionStorage.getItem('fru21526LandingQuestion')
        || window.sessionStorage.getItem('fru21526AssistantIntent')
      );
    } catch (e) {
      return false;
    }
  }

  private fallbackInvalidAssistantAutoStart(): void {
    this.assistantLaunchPending = false;
    this.aiAssistantEnabled = false;
    this.showAiAssistantSwitch = false;
    this.showAssistant = false;

    const queryParams = { ...this.route.snapshot.queryParams };
    const hasLoanPurpose = queryParams.LoanPurpose || queryParams.loanPurpose || queryParams.loanpurpose;
    delete queryParams.startAssistant;
    delete queryParams.assistantSource;
    delete queryParams.step;
    if (hasLoanPurpose) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ...queryParams, startAssistant: '0' },
        replaceUrl: true,
      });
      return;
    }

    // FRU-21526: full-page redirect to the REAL (PHP) landing — the Angular /form-landing route
    // renders the legacy component (stale dev rates + NG0303 crash on this branch). Never route there.
    const q = new URLSearchParams(queryParams as any).toString();
    window.location.replace('/communication/form-landing' + (q ? '?' + q : ''));
  }

  startAiAssistantFromButton(): void {
    if (this.isDscrInvestmentFlow()) { return; }
    const fromStep = this.steps?.[this.currentStepKey]?.key || 'landing';
    this.analyticsService.trackAssistantOpen(); // FRU-21436: Matomo goal 139 AI Rate Finder Click (1/visitor)
    this.analyticsService.trackAssistantSwitch(fromStep, 'to_assistant'); // FRU-21436 flip tracking
    this.recordRateFinderModeSwitch(fromStep, 'to_assistant');
    this.aiAssistantEnabled = true;
    this.showAiAssistantSwitch = false;
    this.router.navigate([], {
      relativeTo: this.route,
      // FRU-21526 tracking gaps (abx review of ec17f69a): tag the source at the REAL switch action so
      // BOTH GA4 and the lead pick it up (URL-read), and ONLY on a genuine switch -- never inferred
      // from a missing source. in_form_switch / ask_hope_button are allowlisted in AnalyticsService.
      queryParams: { startAssistant: '1', assistantSource: 'in_form_switch', assistantEntry: 'ask_hope_button' },
      queryParamsHandling: 'merge',
    }).then(() => {
      this.openAiAssistant();
    });
  }

  // FRU-21436: open the chat automatically on load when ?startAssistant=1 is present AND the
  // assistant is enabled. Guarded so it fires exactly once. Deferred with setTimeout(0) so it runs
  // after the component/view is initialized and the *ngIf host container can resolve.
  private maybeAutoStartAssistant(): void {
    if (this.autoStartAssistantFired) { return; }
    if (!this.shouldStartAssistantFromUrl()) { return; }
    if (!this.aiAssistantEnabled) {
      this.assistantLaunchPending = false;
      return;
    }
    if (!this.form) {
      setTimeout(() => { this.maybeAutoStartAssistant(); }, 0);
      return;
    }
    this.autoStartAssistantFired = true;
    this.analyticsService.trackAssistantOpen();
    setTimeout(() => { this.openAiAssistant(); }, 0);
  }

  // FRU-21436: instant, in-place flip to the LowRateFinder chat. Same app, same URL, no navigation,
  // no serialization. The chat subsystem (ChatComponent + its step components + chat/steps services)
  // lives in a SEPARATE lazy chunk that is only downloaded the first time the user taps the flip, so the
  // form page stays lightweight. We snapshot the live in-memory form answers and hand them to the chat
  // as a seed so the user progress is preserved on the flip.
  async openAiAssistant(): Promise<void> {
    if (this.isDscrInvestmentFlow()) { return; }
    this.assistantLoadFailed = false;
    const assistantSource = this.route.snapshot.queryParams['assistantSource'];
    addRateFinderBreadcrumb('assistant_open', {
      from_step: this.steps?.[this.currentStepKey]?.key || 'landing',
      source: (Array.isArray(assistantSource) ? assistantSource[0] : assistantSource) || 'direct',
    });
    updateRateFinderSentryContext({ mode: 'assistant', step: this.steps?.[this.currentStepKey]?.key || 'landing' });
    const bareDirectAssistantStart = this.isBareDirectAssistantStart();
    this.assistantSeed = bareDirectAssistantStart ? {} : { ...this.form.value };
    this.assistantSeedCarryover = {};
    const qp = this.route.snapshot.queryParams || {};
    const seededLoanPurpose = this.assistantSeed['loanPurpose'] || this.assistantSeed['type'] || qp['LoanPurpose'] || qp['loanPurpose'] || qp['loanpurpose'];
    if (seededLoanPurpose && !this.assistantSeed['loanPurpose']) {
      this.assistantSeed['loanPurpose'] = Array.isArray(seededLoanPurpose) ? seededLoanPurpose[0] : seededLoanPurpose;
    }
    if (seededLoanPurpose && !this.assistantSeed['type']) {
      this.assistantSeed['type'] = Array.isArray(seededLoanPurpose) ? seededLoanPurpose[0] : seededLoanPurpose;
    }
    if (qp['FormType'] && !this.assistantSeed['FormType']) {
      this.assistantSeed['FormType'] = Array.isArray(qp['FormType']) ? qp['FormType'][0] : qp['FormType'];
    }
    if (qp['lp_button'] && !this.assistantSeed['lp_button']) {
      this.assistantSeed['lp_button'] = Array.isArray(qp['lp_button']) ? qp['lp_button'][0] : qp['lp_button'];
    }
    // FRU-21526: amount cards on the AI-box landing store the picked amount — hand it to the chat
    // as a seeded cashOut answer so Hope acknowledges it instead of re-asking.
    try {
      const storedCashout = window.sessionStorage.getItem('fru21526CashoutAmount');
      if (storedCashout && !this.assistantSeed['cashOut']) {
        this.assistantSeed['cashOut'] = storedCashout;
        this.assistantSeedCarryover['cashOut'] = storedCashout;
      }
    } catch (e) { /* non-fatal */ }
    // FRU-21526: consume the ad-keyword assumptions the landing parsed (whatever the visitor searched,
    // assume they ARE that). Pre-fill so Hope can acknowledge + skip known steps (shopping tool, they
    // adjust later). Only fills empty seeds; TCPA consent (phone) is never touched by this.
    try {
      const rawCtx = window.sessionStorage.getItem('fru21526AiLandingContext');
      if (rawCtx) {
        const parsedCtx = (JSON.parse(rawCtx) || {});
        const a = parsedCtx.assumed;
        // abx (seq134 #2): only honor the landing's parsed ad-keyword assumptions when the context is
        // FRESH (written this session, <= 30 min ago). A stale context from an earlier landing visit in
        // the same tab must NOT silently seed credit/property/veteran/cash onto a later DIRECT visit.
        const createdAt = Number(parsedCtx.created_at || 0);
        const fresh = createdAt > 0 && (Date.now() - createdAt) <= 30 * 60 * 1000;
        if (a && typeof a === 'object' && fresh) {
          const map: { [k: string]: string } = {
            propertyType: 'propertyType',
            propertyUse: 'propertyUse',
            credit: 'creditRating',
            veteran: 'veteranMilitary',
            fha: 'currentFHA',
          };
          Object.keys(map).forEach((k) => {
            if (a[k] && !this.assistantSeed[map[k]]) {
              this.assistantSeed[map[k]] = a[k];
              this.assistantSeedCarryover[map[k]] = a[k];
            }
          });
          if (a.cashAmount && !this.assistantSeed['cashOut']) {
            this.assistantSeed['cashOut'] = a.cashAmount;
            this.assistantSeedCarryover['cashOut'] = a.cashAmount;
            if (!this.assistantSeed['maximumEquity']) {
              this.assistantSeed['maximumEquity'] = 'no';
              this.assistantSeedCarryover['maximumEquity'] = 'no';
            }
          }
        }
      }
    } catch (e) { /* non-fatal */ }
    // Read handoff data without consuming it. A stale/deleted chunk must not erase the visitor's
    // landing question, amount, or keyword assumptions before Hope actually mounts.
    const landingQuestion = this.readLandingAssistantQuestion();
    // FRU-21436: hand the chat the EXACT question the visitor is currently viewing so the chat opens
    // ON that step, not one past it. Inferring the resume point from seed values alone over-advances,
    // because the current (unanswered) step frequently already has a default/empty-but-present control
    // value and gets miscounted as "answered". The current step key is authoritative.
    const currentRouteStep = this.route.snapshot.queryParams['step'];
    const currentRouteStepKey = Array.isArray(currentRouteStep) ? currentRouteStep[0] : currentRouteStep;
    let currentKey = this.mapFormStepToAssistantStep(currentRouteStepKey || (this.steps?.[this.currentStepKey]?.key ?? null));
    const wasAssistantOpen = this.showAssistant;
    if (this.assistantComponentRef) {
      // An already-created chat can be shown immediately. A first-time in-form switch stays on
      // usable Classic until import resolves; a direct entry keeps its boot surface instead.
      this.showAssistant = true;
      this.assistantLaunchPending = false;
      this.aiRateFinderChatService.suppressLoanPurposeIntro = !!landingQuestion;
      this.assistantComponentRef.instance.resumeAtStepKey = currentKey;
      this.assistantComponentRef.instance.seedAnswers = this.assistantSeed;
      this.assistantComponentRef.instance.officeStatus = this.officeStatus;
      if (landingQuestion) {
        this.assistantComponentRef.instance.initialLandingQuestion = landingQuestion;
      }
      const handoffApplied = this.resumeAssistantComponentFromSeed();
      if (!handoffApplied) {
        updateRateFinderSentryContext({ mode: 'form', step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose' });
        this.settleAssistantImportFailure(this.seedFailureRecoveryAction());
        return;
      }
      this.commitAssistantHandoffState();
      this.hasAIModeBeenEnabled = true;
      if (!wasAssistantOpen) {
        this.pushAssistantHistoryState();
      }
      return;
    }
    if (this.assistantLoading) {
      return;
    }
    this.assistantLoading = true;
    addRateFinderBreadcrumb('assistant_chunk_load_start', { source: 'interactive_open' });
    try {
      // Dynamic import => Angular code-splits this into its own async chunk.
      const m = await this.assistantModuleLoader();
      // Classic remains interactive during an in-form lazy load. Respect a Back/cancel that removed
      // startAssistant while the request was pending, and never reopen Hope after that intent changed.
      if (this.cancelPendingAssistantLaunchIfUrlChanged()) { return; }
      // The visitor may have answered or advanced Classic while the module downloaded. Refresh both
      // the seed and resume step at the handoff boundary so Hope opens on the latest live progress.
      currentKey = this.refreshAssistantSeedFromLiveForm();
      const moduleRef = createNgModule(m.AssistantModule, this.injector);
      // Force CD so the *ngIf="showAssistant" host container is rendered and @ViewChild resolves.
      this.showAssistant = true;
      this.assistantLaunchPending = false;
      this.cdr.detectChanges();
      if (!this.showAssistant) {
        this.assistantLoading = false;
        return;
      }
      if (!this.assistantHost) {
        throw new Error('Hope assistant host did not mount');
      }
      this.assistantHost.clear();
      this.assistantComponentRef = this.assistantHost.createComponent(m.ChatComponent, { ngModuleRef: moduleRef });
      this.aiRateFinderChatService.suppressLoanPurposeIntro = !!landingQuestion;
      this.assistantComponentRef.instance.resumeAtStepKey = currentKey;
      this.assistantComponentRef.instance.seedAnswers = this.assistantSeed;
      this.assistantComponentRef.instance.initialLandingQuestion = landingQuestion;
      this.assistantComponentRef.instance.officeStatus = this.officeStatus;
      const handoffApplied = this.resumeAssistantComponentFromSeed();
      if (!handoffApplied) {
        updateRateFinderSentryContext({ mode: 'form', step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose' });
        this.settleAssistantImportFailure(this.seedFailureRecoveryAction());
        return;
      }
      this.assistantComponentRef.changeDetectorRef.detectChanges();
      this.commitAssistantHandoffState();
      this.hasAIModeBeenEnabled = true;
      this.pushAssistantHistoryState();
      addRateFinderBreadcrumb('assistant_chunk_load_success', { source: 'interactive_open' });
    } catch (e) {
      // A rejection can arrive after the same Back/cancel race as a successful import. The visitor's
      // explicit choice wins: do not report a load failure, hide the switch, or strip form state.
      if (this.cancelPendingAssistantLaunchIfUrlChanged()) { return; }
      console.error('FRU-21436: failed to load the AI assistant chunk', e);
      const recoveryAction = this.recoverAssistantImport('interactive_open');
      if (claimAssistantFailureReport()) {
        captureRateFinderException(e, 'assistant_chunk_load_failure', {
          source: 'interactive_open',
          recovery_action: recoveryAction,
        });
      }
      updateRateFinderSentryContext({ mode: 'form', step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose' });
      this.settleAssistantImportFailure(recoveryAction);
    } finally {
      this.assistantLoading = false;
    }
  }

  private isBareDirectAssistantStart(): boolean {
    const qp = this.route?.snapshot?.queryParams || {};
    const one = (key: string) => Array.isArray(qp[key]) ? qp[key][0] : qp[key];
    return one('startAssistant') === '1'
      && !one('assistantSource')
      && !one('assistantEntry')
      && !one('experience')
      && !one('step')
      && !one('LoanPurpose')
      && !one('loanPurpose')
      && !one('loanpurpose')
      && !one('FormType')
      && !one('formType')
      && !one('lp_button')
      && !one('type')
      && !one('calc')
      && !one('calcSkin');
  }

  private cancelPendingAssistantLaunchIfUrlChanged(): boolean {
    if (this.shouldStartAssistantFromUrl()) { return false; }
    this.assistantLaunchPending = false;
    this.showAssistant = false;
    this.syncAssistantExperimentFromUrl();
    updateRateFinderSentryContext({ mode: 'form', step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose' });
    try {
      const bootDone = (window as any).__hopeBootDone;
      if (typeof bootDone === 'function') { bootDone(); }
    } catch (e) { /* non-fatal */ }
    try { this.cdr.detectChanges(); } catch (e) { /* non-fatal */ }
    return true;
  }

  private refreshAssistantSeedFromLiveForm(): string | null {
    const qp = this.route?.snapshot?.queryParams || {};
    const liveValues = this.form?.value || {};
    const controls = this.form?.controls || {};
    if (this.isBareDirectAssistantStart()) {
      this.assistantSeed = {};
      this.assistantSeedCarryover = {};
      return this.mapFormStepToAssistantStep(qp['step'] || null);
    }
    const refreshedSeed: { [key: string]: any } = { ...this.assistantSeedCarryover };
    Object.keys(liveValues).forEach((key) => {
      const value = liveValues[key];
      const control = controls[key];
      const empty = value === null || value === undefined || value === '';
      const hasCarryover = Object.prototype.hasOwnProperty.call(refreshedSeed, key);
      // An untouched empty control must not erase an intentional landing assumption. A meaningful
      // value—or an explicitly touched/dirty clear—is live consumer truth and always wins.
      if (!hasCarryover || !empty || control?.dirty || control?.touched) {
        refreshedSeed[key] = value;
      }
    });
    this.assistantSeed = refreshedSeed;

    let liveSearch: URLSearchParams | null = null;
    try {
      if (typeof window !== 'undefined') { liveSearch = new URLSearchParams(window.location.search); }
    } catch (e) { /* use the route snapshot only outside a live browser */ }
    const queryValue = (...keys: string[]): any => {
      for (const key of keys) {
        if (liveSearch) {
          if (liveSearch.has(key)) { return liveSearch.get(key); }
        } else if (qp[key] !== undefined && qp[key] !== null) {
          return Array.isArray(qp[key]) ? qp[key][0] : qp[key];
        }
      }
      return null;
    };

    const liveLoanPurpose = liveValues['loanPurpose'] || liveValues['type']
      || queryValue('LoanPurpose', 'loanPurpose', 'loanpurpose');
    if (liveLoanPurpose) {
      const scalarLoanPurpose = Array.isArray(liveLoanPurpose) ? liveLoanPurpose[0] : liveLoanPurpose;
      this.assistantSeed['loanPurpose'] = scalarLoanPurpose;
      this.assistantSeed['type'] = scalarLoanPurpose;
    }
    const liveFormType = liveValues['formType'] || liveValues['FormType']
      || queryValue('FormType', 'formType');
    if (liveFormType) {
      this.assistantSeed['FormType'] = Array.isArray(liveFormType) ? liveFormType[0] : liveFormType;
    }
    const liveLpButton = liveValues['lp_button'] || queryValue('lp_button');
    if (liveLpButton) {
      this.assistantSeed['lp_button'] = Array.isArray(liveLpButton) ? liveLpButton[0] : liveLpButton;
    }

    const liveStepKey = this.steps?.[this.currentStepKey]?.key || queryValue('step');
    return this.mapFormStepToAssistantStep(liveStepKey || null);
  }

  private settleAssistantImportFailure(recoveryAction: AssistantImportRecoveryAction): void {
    this.assistantLoadFailed = true;
    this.assistantLaunchPending = false;
    this.aiAssistantEnabled = false;
    this.showAiAssistantSwitch = false;
    this.showAssistant = false;

    if (this.assistantComponentRef) {
      try { this.assistantComponentRef.destroy(); } catch (e) { /* non-fatal */ }
      this.assistantComponentRef = null;
    }
    if (this.assistantHost) {
      try { this.assistantHost.clear(); } catch (e) { /* non-fatal */ }
    }

    const step = this.steps?.[this.currentStepKey]?.key || 'loanPurpose';
    this.queueRateFinderAction('assistant_load_failure', step, '', {
      arm: 'assistant',
      surface: 'ai_assistant',
      recovery_action: recoveryAction,
      source: this.route.snapshot.queryParams['assistantSource'] || 'direct',
    });

    // Remove failed Hope attribution while preserving every product, campaign and current-step
    // parameter. hbretry=1 intentionally remains as the one-shot loop guard.
    try {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          startAssistant: null,
          assistantSource: null,
          assistantEntry: null,
        },
        queryParamsHandling: 'merge',
        preserveFragment: true,
        replaceUrl: true,
      });
    } catch (e) { /* the already-rendered classic path remains usable */ }

    try { this.cdr.detectChanges(); } catch (e) { /* non-fatal */ }
    // Keep the stable shell over the first-attempt fallback until the already-owned one-shot
    // navigation begins. A second direct failure or an in-form failure has no navigation coming,
    // so expose the usable Classic form immediately. If Angular itself never boots, this method
    // never runs and the 15s manual retry remains visible.
    if (recoveryAction !== 'auto_reload') {
      try {
        const bootDone = (window as any).__hopeBootDone;
        if (typeof bootDone === 'function') { bootDone(); }
      } catch (e) { /* non-fatal */ }
    }
  }

  private seedFailureRecoveryAction(): AssistantImportRecoveryAction {
    const source = this.route?.snapshot?.queryParams?.['assistantSource'];
    const scalarSource = Array.isArray(source) ? source[0] : source;
    return scalarSource === 'in_form_switch' ? 'stay_on_form' : 'fallback_form';
  }

  private resumeAssistantComponentFromSeed(): boolean {
    try {
      const instance: any = this.assistantComponentRef && this.assistantComponentRef.instance;
      if (!instance) { return false; }
      if (typeof instance.applySeedAnswers === 'function') {
        instance.applySeedAnswers(true);
      }
      if (typeof instance.resumeFromSeed === 'function') {
        instance.resumeFromSeed();
      }
      return true;
    } catch (e) {
      captureRateFinderException(e, 'assistant_seed_failure', {
        source: 'interactive_open',
        step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose',
      });
      return false;
    }
  }

  // FRU-21436: flip back to the traditional rates form. The form state is untouched, so the form is
  // exactly as the user left it. We destroy the chat instance to free memory; the lazy chunk stays cached.
  closeAiAssistant(): void {
    this.rateFreshness.clear();
    this.showAssistant = false;
    if (this.assistantComponentRef) {
      this.assistantComponentRef.destroy();
      this.assistantComponentRef = null;
    }
    if (this.assistantHost) {
      this.assistantHost.clear();
    }
  }

  // FRU-21436: "Switch Back" reverse handoff. The chat carries its own copy of the answers; before we
  // flip back we read the live chat form values, copy every answered control onto THIS form (same
  // field keys), reposition the form at the furthest point the visitor reached in the chat, then close
  // the chat. So form -> chat -> form preserves progress in BOTH directions.
  // Ed 7/7: hide the 'Continue without AI' link on the phone/consent step.
  get assistantOnPhoneStep(): boolean {
    try {
      const inst: any = this.assistantComponentRef && this.assistantComponentRef.instance;
      return !!(inst && inst.steps && inst.steps[inst.currentStepIndex] && inst.steps[inst.currentStepIndex].key === 'phone');
    } catch (e) { return false; }
  }

  switchBackToForm(fromPopState: boolean = false): void {
    const sentryAssistantStep = this.assistantComponentRef?.instance?.steps?.[this.assistantComponentRef?.instance?.currentStepIndex]?.key || 'assistant';
    addRateFinderBreadcrumb('switchback', {
      from_step: sentryAssistantStep,
      mode: 'assistant',
      source: fromPopState ? 'browser_back' : 'switch_link',
    });
    try { const _fs = this.assistantComponentRef?.instance?.steps?.[this.assistantComponentRef?.instance?.currentStepIndex]?.key || 'assistant'; this.analyticsService.trackAssistantSwitch(_fs, 'to_form'); this.recordRateFinderModeSwitch(_fs, 'to_form'); } catch (e) { /* non-fatal */ } // FRU-21436 flip tracking
    if (this.shouldSwitchAssistantBackToLanding()) {
      this.closeAiAssistant();
      const queryParams = { ...this.route.snapshot.queryParams };
      delete queryParams.startAssistant;
      delete queryParams.assistantSource;
      delete queryParams.step;
      const query = new URLSearchParams(queryParams).toString();
      window.location.href = '/communication/form-landing' + (query ? '?' + query : '');
      return;
    }

    let chatValues: { [key: string]: any } | null = null;
    const chatStepKey = this.assistantComponentRef?.instance?.steps?.[this.assistantComponentRef?.instance?.currentStepIndex]?.key || null;
    try {
      chatValues = this.assistantComponentRef?.instance?.form?.value || null;
      if (chatValues && typeof chatValues === 'object') {
        // Translate chat answers to FORM control names (the two trees differ: chat `phone` ->
        // form `phoneNumber`; the rest share names). Stash as the switch-back seed so activateStep()
        // can (re)apply them as each step's controls come into existence.
        this.switchBackSeed = this.translateChatAnswersToForm(chatValues);
        this.syncFormLoanPurposeFromChat(chatValues);
        // Apply to any controls that already exist right now.
        this.applySwitchBackSeed();
      }
    } catch (e) {
      // Reverse handoff is best-effort: never let it block the flip back.
      console.error('FRU-21436: switch-back handoff failed, flipping back without reposition', e);
    }
    // FRU-21436: a "Switch Back" is not an exit — suppress the exit-intent popup so it never blocks
    // the form on return (AG). Clear any open popup and mark it seen so it won't fire on this session.
    this.userExiting = false;
    this.hasSeenPopup = true;
    this.closeAiAssistant();
    this.aiAssistantEnabled = true;
    this.showAiAssistantSwitch = true;
    this.assistantLaunchPending = false;
    this.cdr.detectChanges();
    this.stepComponents = this.stepComponentList ? this.stepComponentList.toArray() : this.stepComponents;
    if (!this.positionFormAtChatStep(chatStepKey) && chatValues && typeof chatValues === 'object') {
      // Land on the first step the visitor has NOT yet answered after the form components are mounted.
      this.positionFormAtFurthestAnswered(chatValues);
    }
    // FRU-21436: keep the URL in sync with the step we actually landed on, and do NOT leave the
    // assistant history sentinel behind. When the user tapped "Switch Back" we replace the sentinel
    // entry with the correct form-step URL; when this came from a browser Back (popstate already
    // consumed the sentinel) we just align the URL to the current step.
    this.syncUrlToCurrentStep('0');
    updateRateFinderSentryContext({ mode: 'form', step: this.steps?.[this.currentStepKey]?.key || 'loanPurpose' });
    if (fromPopState) {
      setTimeout(() => {
        this.aiAssistantEnabled = true;
        this.showAiAssistantSwitch = true;
        this.assistantLaunchPending = false;
        this.positionFormAtChatStep(chatStepKey);
        this.cdr.detectChanges();
      }, 0);
    }
  }

  // FRU-21436: push a same-URL history entry that marks "assistant is open" so Back closes the
  // assistant instead of navigating away to a stale/blank state.
  private pushAssistantHistoryState(): void {
    try {
      const url = window.location.pathname + window.location.search;
      window.history.pushState({ fruAssistantOpen: true }, '', url);
    } catch (e) { /* history unavailable: non-fatal */ }
  }

  // FRU-21436: align the browser URL's `step` query param with the form's current step, without
  // adding a history entry (replaceUrl), so URL and on-screen step never desync after a mode flip.
  private syncUrlToCurrentStep(startAssistant: '0' | '1' | null = null): void {
    try {
      const key = this.steps?.[this.currentStepKey]?.key;
      if (!key) { return; }
      const queryParams: any = { step: key };
      if (startAssistant !== null) {
        queryParams.startAssistant = startAssistant;
      }
      if (startAssistant === '0') {
        const qp = this.route.snapshot.queryParams || {};
        const scalar = (v: any) => Array.isArray(v) ? (v[0] ?? '') : (v || '');
        const isHomeEquityCalculator = scalar(qp['calc']) === 'homeequity';
        const routeFormType = scalar(qp['FormType']).toLowerCase();
        const routeLpButton = scalar(qp['lp_button']).toLowerCase();
        queryParams.assistantSource = null;
        queryParams.LoanPurpose = this.type || null;
        queryParams.FormType = (isHomeEquityCalculator ? routeFormType : '') || this.formType || routeFormType || null;
        queryParams.lp_button = (isHomeEquityCalculator ? routeLpButton : '') || this.lp_button || routeLpButton || null;
        // The user explicitly chose the non-AI form path. Do not keep the calculator FAST
        // automation running underneath the returned form step.
        queryParams.auto_mode = null;
        queryParams.fast_mode_enabled_step = null;
        if (this.fastMode.enabled) {
          this.fastMode.disable();
        }
        this.isFastModeAllowed = false;
      }
      this.router.navigate(['/rates-form'], {
        queryParams: queryParams,
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    } catch (e) { /* non-fatal */ }
  }

  // FRU-21436: browser Back handling. If the assistant is open, Back should just CLOSE it (a mode
  // toggle), carrying progress back to the form, rather than unwinding to a stale or blank URL.
  @HostListener('window:popstate', ['$event'])
  onPopState(_event: Event): void {
    if (this.showAssistant) {
      const backStep = this.assistantComponentRef?.instance?.steps?.[this.assistantComponentRef?.instance?.currentStepIndex]?.key || 'assistant';
      addRateFinderBreadcrumb('browser_back', {
        step: backStep,
        mode: 'assistant',
      });
      this.sendRateFinderBackAction('browser_back', backStep, '', {
        arm: 'assistant',
        surface: 'ai_assistant',
        from_step: backStep,
      });
      // Ed 7/14: mobile users tap Back expecting the PREVIOUS QUESTION — exiting Hope to the classic
      // form behaved as an abandon leak. Step the chat back one question and re-arm the history
      // sentinel; only when the chat can't go back further does Back exit (original behavior).
      try {
        const inst: any = this.assistantComponentRef && this.assistantComponentRef.instance;
        const svc: any = inst && (inst.chatService || inst['chatService']);
        // FRU-23719: Hope says whether Back went somewhere (a calculator stage or the previous question). Asking only whether
        // it could left Back doing nothing on the home equity calculator, whose earlier questions were answered for the visitor.
        const went = inst && typeof inst.browserBack === 'function'
          ? inst.browserBack()
          : (svc && svc.canGoBackNow ? (svc.requestBack(), 'moved') : 'none');
        if (went !== 'none') {
          this.pushAssistantHistoryState();
          return;
        }
      } catch (e) { /* fall through to the exit path */ }
      // FRU-23719: where Hope opened before this form built a step (the loan type landing, the mortgage calculator), handing
      // over left an empty page. Back leaves the site instead, as it does from this form's first screen; with no page before
      // this one (a new tab), Hope stays open.
      if (!this.assistantHandoverHasStep()) {
        if (this.hasEarlierPage()) { window.history.back(); } else { this.pushAssistantHistoryState(); }
        return;
      }
      this.switchBackToForm(true);
      // If the hand-over still shows no step, leave rather than stay on an empty page.
      setTimeout(() => {
        try {
          if (!this.showAssistant && !(this.stepComponentList && this.stepComponentList.length) && this.hasEarlierPage()) { window.history.back(); }
        } catch (e) { /* non-fatal */ }
      }, 0);
      return;
    }

    try {
      const fromStep = this.steps?.[this.currentStepKey]?.key || 'form_landing';
      const destinationStep = new URL(window.location.href).searchParams.get('step') || 'form_landing';
      if (destinationStep !== fromStep) {
        this.sendRateFinderBackAction('browser_history', destinationStep, '', {
          arm: 'form',
          surface: 'classic_form',
          navigation_type: 'popstate',
          from_step: fromStep,
          to_step: destinationStep,
        });
      }
    } catch (e) { /* telemetry must never own browser navigation */ }
  }

  // FRU-21436: map chat answer keys -> form control keys. Only `phone` differs; everything else
  // (zipCode, streetAddress, firstName, lastName, email, propertyType, ...) shares the same name.
  private translateChatAnswersToForm(chatValues: { [key: string]: any }): { [key: string]: any } {
    const rename: { [k: string]: string } = { phone: 'phoneNumber' };
    const seed: { [key: string]: any } = {};
    Object.keys(chatValues).forEach((k) => {
      const v = chatValues[k];
      if (v === null || v === undefined || v === '') { return; }
      seed[rename[k] || k] = v;
    });
    return seed;
  }

  private positionFormAtChatStep(chatStepKey: string | null): boolean {
    if (!chatStepKey || !Array.isArray(this.steps) || !this.steps.length) { return false; }
    const chatToFormStep: { [key: string]: string } = {
      zipCode: 'zipCodeStreetAddress',
      streetAddress: 'zipCodeStreetAddress',
      firstName: 'firstNameLastName',
      lastName: 'firstNameLastName',
      phone: 'phone',
    };
    const formStepKey = chatToFormStep[chatStepKey] || chatStepKey;
    const target = this.steps.findIndex((step) => step && step.key === formStepKey);
    if (target < 0) { return false; }
    this.activateStep(target, false);
    return true;
  }

  private syncFormLoanPurposeFromChat(chatValues: { [key: string]: any }): void {
    const formQuery = this.formQueryFromChat(chatValues);
    if (!formQuery) { return; }

    this.type = formQuery.loanPurpose;
    this.formType = formQuery.formType;
    this.lp_button = formQuery.lpButton;
    this.setFormControlValue('type', this.type);
    this.setFormControlValue('formType', this.formType);
    this.setFormControlValue('lp_button', this.lp_button);
    this.initializeSteps(false, this.type, this.lp_button);
  }

  /** The loan type this form takes from Hope's answers (or the URL) on a hand-over, or null when there is none. */
  private formQueryFromChat(chatValues: { [key: string]: any }): { loanPurpose: string, formType: string, lpButton: string } | null {
    const qp = this.route.snapshot.queryParams || {};
    const scalar = (v: any) => Array.isArray(v) ? (v[0] ?? '') : (v || '');
    const loanPurpose = (chatValues.loanPurpose || chatValues.type || scalar(qp['LoanPurpose']) || '').toString().toLowerCase();
    const formTypeSignal = (chatValues.FormType || chatValues.formType || scalar(qp['FormType']) || this.formType || '').toString().toLowerCase();
    const lpButtonSignal = (chatValues.lp_button || scalar(qp['lp_button']) || this.lp_button || '').toString().toLowerCase();
    const lpButtonByFormType: { [key: string]: string } = {
      heloc: 'homeequity',
      cashout: 'cashout',
      homeimprovement: 'homeimprovement',
    };
    const formQueryByLoanPurpose: { [key: string]: { loanPurpose: string, formType: string, lpButton: string } } = {
      refinance: { loanPurpose: 'refinance', formType: '', lpButton: 'refinance' },
      purchase: { loanPurpose: 'purchase', formType: '', lpButton: 'purchase' },
      heloc: { loanPurpose: 'refinance', formType: 'heloc', lpButton: 'homeequity' },
      cashout: { loanPurpose: 'refinance', formType: 'cashout', lpButton: 'cashout' },
      homeimprovement: { loanPurpose: 'refinance', formType: 'homeimprovement', lpButton: 'homeimprovement' },
    };
    let formQuery = formQueryByLoanPurpose[loanPurpose];
    if (loanPurpose === 'refinance' && formTypeSignal) {
      formQuery = {
        loanPurpose: 'refinance',
        formType: formTypeSignal,
        lpButton: lpButtonSignal || lpButtonByFormType[formTypeSignal] || 'refinance',
      };
    }
    return formQuery || null;
  }

  /**
   * FRU-23719: whether handing over from Hope gives this form a step to show. Its steps come from the URL's loan type, or
   * from Hope's answers on the hand-over; with neither (the loan type landing, the mortgage calculator) it has none.
   */
  private assistantHandoverHasStep(): boolean {
    if (Array.isArray(this.steps) && this.steps.length) { return true; }
    try {
      const chatValues: any = this.assistantComponentRef?.instance?.form?.value || {};
      return !!this.formQueryFromChat(chatValues);
    } catch (e) { return true; }   // unsure: keep the existing hand-over
  }

  /** FRU-23719: whether Back has a page before this one to go to (Hope's own entry is the one after it). */
  private hasEarlierPage(): boolean {
    try { return window.history.length > 2; } catch (e) { return false; }
  }

  // FRU-21436: push the stashed switch-back answers into any form controls that currently exist, and
  // revalidate so a carried value (e.g. a valid ZIP) does not show a stale "required/invalid" error.
  private applySwitchBackSeed(): void {
    if (!this.switchBackSeed) { return; }
    Object.keys(this.switchBackSeed).forEach((key) => {
      if (this.form.contains(key)) {
        const ctrl = this.form.controls[key];
        if (ctrl.value !== this.switchBackSeed[key]) {
          ctrl.setValue(this.switchBackSeed[key]);
        }
        ctrl.markAsTouched();
        ctrl.updateValueAndValidity();
      }
    });
  }

  // FRU-21436: land the form on the first step that is still unanswered after the chat handoff. The
  // form and chat step trees differ (the form COMBINES zip+address and first+last into single steps),
  // so a form step counts as answered when ALL its underlying chat answers are present.
  private positionFormAtFurthestAnswered(chatValues: { [key: string]: any }): void {
    if (!Array.isArray(this.steps) || !this.steps.length) { return; }
    // form step key -> the chat answer key(s) that make it "answered".
    const stepToChatKeys: { [k: string]: string[] } = {
      zipCodeStreetAddress: ['zipCode', 'streetAddress'],
      firstNameLastName: ['firstName', 'lastName'],
      phone: ['phone'],
    };
    const has = (k: string) => {
      const v = chatValues[k];
      return v !== undefined && v !== null && v !== '';
    };
    let target = -1;
    for (let i = 0; i < this.steps.length; i++) {
      const step = this.steps[i];
      const key = step && step.key;
      if (!key) { continue; }
      // Respect the same require() gating the form uses, so we do not stop on a step this visitor skips.
      if (typeof step.require === 'function') {
        let included = true;
        try { included = !!step.require(); } catch (e) { included = true; }
        if (!included) { continue; }
      }
      const chatKeys = stepToChatKeys[key] || [key];
      const answered = chatKeys.every(has);
      if (!answered) { target = i; break; }
    }
    if (target < 0) {
      // Everything is answered: land on the last step so the visitor can submit.
      target = this.steps.length - 1;
    }
    this.activateStep(target, false);
  }

  get ratesFormHeaderLabel(): string {
    switch (this.brandService.domain) {
      case 'homeequitychoice.com':
        return 'HomeEquityChoice.com';
      case 'besthomeequityloan.com':
        return 'BestHomeEquityLoan.com';
      default:
        return '';
    }
  }

  getThemeName(): string {
    switch (this.brandService.data.domain) {
      default:
        return '';
    }
  }

  /** FRU-23951: whether Hope's header shows Ask Hope (Hope decides: on, and the step has a message box to open). */
  get askHopeHeaderVisible(): boolean {
    try {
      const chat: any = this.assistantComponentRef && this.assistantComponentRef.instance;
      return !!(chat && chat.askHopeHeaderVisible);
    } catch (e) { return false; }
  }

  /** FRU-23952: Hope is on its phone (submit) step, where a phone hides the call card, as the original form does on its own. */
  get hopeOnPhoneStep(): boolean {
    try {
      const chat: any = this.assistantComponentRef && this.assistantComponentRef.instance;
      const step = chat && chat.steps && chat.steps[chat.currentStepIndex];
      return !!(step && step.key === 'phone');
    } catch (e) { return false; }
  }

  /** FRU-23951: the header's Ask Hope opens Hope's message box, inside the tap. */
  openAskHope(): void {
    try {
      const chat: any = this.assistantComponentRef && this.assistantComponentRef.instance;
      if (chat && typeof chat.openAskHopeFromHeader === 'function') { chat.openAskHopeFromHeader(); }
    } catch (e) { /* non-fatal */ }
  }

  phoneClicked() {
    window['_paq'].push(['trackGoal', 94]);
  }

  phoneClicked2() {
    window['_paq'].push(['trackGoal', 92]);
  }

  setDefaultSelectedResponse(listSource, nsLeadId = 0) {
    if(this.cancelSelectedRequest || !this.form.contains('selectedListSource')) {
      return;
    }

    this.cancelSelectedRequest = true;

    let response = this.defaultResponse;

    this.availableSelected$.next(response);
    this.notSubmitedLeadId = response.lead_id;
    this.form.controls.selectedListSource.setValue(listSource);
    this.form.controls.nsLeadId.setValue(nsLeadId ? nsLeadId : response.lead_id);
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    response.lenders.forEach(value => {
      if (value.checked) {
        lenderArray.push(new UntypedFormControl(value?.id));
      }
      lenderList.push(new UntypedFormControl(value));
    });
  }
}
